export const PRODUCTS = () => {
  return [
    {
      "id": "prod152131135",
      "name": "Checked Tweed Jacket",
      "displayable": true,
      "canonical": "/p/kiton-checked-tweed-jacket-prod152131135",
      "designer": "Kiton",
      "cmosCatalog": "BGS20",
      "cmosItem": "B5A9B",
      "pimStyle": "3296064",
      "media": {
        "main": {
          "thumbnail": {
            "tag": "mnull"
          },
          "medium": {
            "url": "https://images.sample.com/ca/1/product_assets/B/5/A/9/B/BGB5A9B_ma.jpg",
            "tag": "ma"
          },
          "large": {
            "tag": "mnull"
          },
          "dynamic": {
            "url": "https://media.sample.com/images/f_auto,q_auto/01/3296064_m/kiton-",
            "tag": "m0"
          }
        },
        "alternate": {
          "a": {
            "thumbnail": {
              "tag": "anull"
            },
            "medium": {
              "url": "https://images.sample.com/ca/1/product_assets/B/5/A/9/B/BGB5A9B_aa.jpg",
              "tag": "aa"
            },
            "large": {
              "tag": "anull"
            },
            "dynamic": {
              "url": "https://media.sample.com/images/f_auto,q_auto/01/3296064_a/kiton-",
              "tag": "a0"
            }
          },
          "b": {
            "thumbnail": {
              "tag": "bnull"
            },
            "medium": {
              "url": "https://images.sample.com/ca/1/product_assets/B/5/A/9/B/BGB5A9B_ba.jpg",
              "tag": "ba"
            },
            "large": {
              "tag": "bnull"
            },
            "dynamic": {
              "url": "https://media.sample.com/images/f_auto,q_auto/01/3296064_b/kiton-",
              "tag": "b0"
            }
          },
          "c": {
            "thumbnail": {
              "tag": "cnull"
            },
            "medium": {
              "url": "https://images.sample.com/ca/1/product_assets/B/5/A/9/B/BGB5A9B_ca.jpg",
              "tag": "ca"
            },
            "large": {
              "tag": "cnull"
            },
            "dynamic": {
              "url": "https://media.sample.com/images/f_auto,q_auto/01/3296064_c/kiton-",
              "tag": "c0"
            }
          },
          "z": {
            "thumbnail": {
              "tag": "znull"
            },
            "medium": {
              "url": "https://images.sample.com/ca/1/product_assets/B/5/A/9/B/BGB5A9B_za.jpg",
              "tag": "za"
            },
            "large": {
              "tag": "znull"
            },
            "dynamic": {
              "url": "https://media.sample.com/images/f_auto,q_auto/01/3296064_z/kiton-",
              "tag": "z0"
            }
          }
        }
      },
      "price": {
        "currencyCode": "$",
        "retailPrice": "4560.00"
      },
      "preOrder": false,
      "productFlags": {
        "hasMoreColors": false,
        "isOnlyAtNM": false,
        "showMonogramLabel": false,
        "isNewArrival": false,
        "inLookBook": false,
        "dynamicImageSkuColor": false,
        "isEditorial": false
      },
      "sellableDate": "2021-01-14 07:00:25",
      "isGroup": false,
      "hasMoreItems": false,
      "source": "REGULAR",
      "onlyXItemsLeftStockLevel": 6,
      "isFavorite": false
    },
    {
      "id": "prod152131183",
      "name": "Flower-Print Coat",
      "displayable": true,
      "canonical": "/p/kiton-flower-print-coat-prod152131183",
      "designer": "Kiton",
      "cmosCatalog": "BGS20",
      "cmosItem": "B5A9U",
      "pimStyle": "3296083",
      "media": {
        "main": {
          "thumbnail": {
            "tag": "mnull"
          },
          "medium": {
            "url": "https://images.sample.com/ca/1/product_assets/B/5/A/9/U/BGB5A9U_ma.jpg",
            "tag": "ma"
          },
          "large": {
            "tag": "mnull"
          },
          "dynamic": {
            "url": "https://media.sample.com/images/f_auto,q_auto/01/3296083_m/kiton-",
            "tag": "m0"
          }
        },
        "alternate": {
          "a": {
            "thumbnail": {
              "tag": "anull"
            },
            "medium": {
              "url": "https://images.sample.com/ca/1/product_assets/B/5/A/9/U/BGB5A9U_aa.jpg",
              "tag": "aa"
            },
            "large": {
              "tag": "anull"
            },
            "dynamic": {
              "url": "https://media.sample.com/images/f_auto,q_auto/01/3296083_a/kiton-",
              "tag": "a0"
            }
          },
          "b": {
            "thumbnail": {
              "tag": "bnull"
            },
            "medium": {
              "url": "https://images.sample.com/ca/1/product_assets/B/5/A/9/U/BGB5A9U_ba.jpg",
              "tag": "ba"
            },
            "large": {
              "tag": "bnull"
            },
            "dynamic": {
              "url": "https://media.sample.com/images/f_auto,q_auto/01/3296083_b/kiton-",
              "tag": "b0"
            }
          },
          "c": {
            "thumbnail": {
              "tag": "cnull"
            },
            "medium": {
              "url": "https://images.sample.com/ca/1/product_assets/B/5/A/9/U/BGB5A9U_ca.jpg",
              "tag": "ca"
            },
            "large": {
              "tag": "cnull"
            },
            "dynamic": {
              "url": "https://media.sample.com/images/f_auto,q_auto/01/3296083_c/kiton-",
              "tag": "c0"
            }
          },
          "z": {
            "thumbnail": {
              "tag": "znull"
            },
            "medium": {
              "url": "https://images.sample.com/ca/1/product_assets/B/5/A/9/U/BGB5A9U_za.jpg",
              "tag": "za"
            },
            "large": {
              "tag": "znull"
            },
            "dynamic": {
              "url": "https://media.sample.com/images/f_auto,q_auto/01/3296083_z/kiton-",
              "tag": "z0"
            }
          }
        }
      },
      "price": {
        "currencyCode": "$",
        "retailPrice": "4375.00"
      },
      "preOrder": false,
      "productFlags": {
        "hasMoreColors": false,
        "isOnlyAtNM": false,
        "showMonogramLabel": false,
        "isNewArrival": false,
        "inLookBook": false,
        "dynamicImageSkuColor": false,
        "isEditorial": false
      },
      "sellableDate": "2021-01-31 18:00:09",
      "isGroup": false,
      "hasMoreItems": false,
      "source": "REGULAR",
      "onlyXItemsLeftStockLevel": 2,
      "isFavorite": false
    },
    {
      "id": "prod147540202",
      "name": "Wool Crepe Coat",
      "displayable": true,
      "canonical": "/p/kiton-wool-crepe-coat-prod147540202",
      "designer": "Kiton",
      "cmosCatalog": "BGS20",
      "cmosItem": "B4YP6",
      "pimStyle": "3044196",
      "media": {
        "main": {
          "thumbnail": {
            "tag": "mnull"
          },
          "medium": {
            "url": "https://images.sample.com/ca/4/product_assets/B/4/Y/P/6/BGB4YP6_ma.jpg",
            "tag": "ma"
          },
          "large": {
            "tag": "mnull"
          },
          "dynamic": {
            "url": "https://media.sample.com/image/upload/b_rgb:e9eaeb/f_auto,q_auto/01/3044196_100106_m",
            "tag": "m0"
          }
        },
        "alternate": {
          "a": {
            "thumbnail": {
              "tag": "anull"
            },
            "medium": {
              "url": "https://images.sample.com/ca/4/product_assets/B/4/Y/P/6/BGB4YP6_aa.jpg",
              "tag": "aa"
            },
            "large": {
              "tag": "anull"
            },
            "dynamic": {
              "url": "https://media.sample.com/images/f_auto,q_auto/01/3044196_100106_a/kiton-wool-crepe-coat",
              "tag": "a0"
            }
          },
          "b": {
            "thumbnail": {
              "tag": "bnull"
            },
            "medium": {
              "url": "https://images.sample.com/ca/4/product_assets/B/4/Y/P/6/BGB4YP6_ba.jpg",
              "tag": "ba"
            },
            "large": {
              "tag": "bnull"
            },
            "dynamic": {
              "url": "https://media.sample.com/images/f_auto,q_auto/01/3044196_100106_b/kiton-wool-crepe-coat",
              "tag": "b0"
            }
          }
        }
      },
      "price": {
        "currencyCode": "$",
        "retailPrice": "4350.00"
      },
      "preOrder": false,
      "productFlags": {
        "hasMoreColors": false,
        "isOnlyAtNM": false,
        "showMonogramLabel": false,
        "isNewArrival": false,
        "inLookBook": false,
        "dynamicImageSkuColor": false,
        "isEditorial": false
      },
      "sellableDate": "2019-08-02 07:00:18",
      "isGroup": false,
      "hasMoreItems": false,
      "source": "REGULAR",
      "onlyXItemsLeftStockLevel": 1,
      "isFavorite": false
    },
    {
      "id": "prod152131038",
      "name": "Long Silk One-Button Jacket",
      "displayable": true,
      "canonical": "/p/kiton-long-silk-one-button-jacket-prod152131038",
      "designer": "Kiton",
      "cmosCatalog": "BGS20",
      "cmosItem": "B5A8S",
      "pimStyle": "3296071",
      "media": {
        "main": {
          "thumbnail": {
            "tag": "mnull"
          },
          "medium": {
            "url": "https://images.sample.com/ca/3/product_assets/B/5/A/8/S/BGB5A8S_ma.jpg",
            "tag": "ma"
          },
          "large": {
            "tag": "mnull"
          },
          "dynamic": {
            "url": "https://media.sample.com/images/f_auto,q_auto/01/3296071_100189_m/kiton-long-silk-jacket",
            "tag": "m0"
          }
        },
        "alternate": {
          "a": {
            "thumbnail": {
              "tag": "anull"
            },
            "medium": {
              "url": "https://images.sample.com/ca/3/product_assets/B/5/A/8/S/BGB5A8S_aa.jpg",
              "tag": "aa"
            },
            "large": {
              "tag": "anull"
            },
            "dynamic": {
              "url": "https://media.sample.com/images/f_auto,q_auto/01/3296071_100189_a/kiton-long-silk-jacket",
              "tag": "a0"
            }
          },
          "b": {
            "thumbnail": {
              "tag": "bnull"
            },
            "medium": {
              "url": "https://images.sample.com/ca/3/product_assets/B/5/A/8/S/BGB5A8S_ba.jpg",
              "tag": "ba"
            },
            "large": {
              "tag": "bnull"
            },
            "dynamic": {
              "url": "https://media.sample.com/images/f_auto,q_auto/01/3296071_100189_b/kiton-long-silk-jacket",
              "tag": "b0"
            }
          },
          "c": {
            "thumbnail": {
              "tag": "cnull"
            },
            "medium": {
              "url": "https://images.sample.com/ca/3/product_assets/B/5/A/8/S/BGB5A8S_ca.jpg",
              "tag": "ca"
            },
            "large": {
              "tag": "cnull"
            },
            "dynamic": {
              "url": "https://media.sample.com/images/f_auto,q_auto/01/3296071_100189_c/kiton-long-silk-jacket",
              "tag": "c0"
            }
          },
          "z": {
            "thumbnail": {
              "tag": "znull"
            },
            "medium": {
              "url": "https://images.sample.com/ca/2/product_assets/B/5/A/8/S/BGB5A8S_za.jpg",
              "tag": "za"
            },
            "large": {
              "tag": "znull"
            },
            "dynamic": {
              "url": "https://media.sample.com/images/f_auto,q_auto/01/3296071_100189_z/kiton-long-silk-jacket",
              "tag": "z0"
            }
          }
        }
      },
      "price": {
        "currencyCode": "$",
        "retailPrice": "3975.00"
      },
      "preOrder": false,
      "productFlags": {
        "hasMoreColors": false,
        "isOnlyAtNM": false,
        "showMonogramLabel": false,
        "isNewArrival": false,
        "inLookBook": false,
        "dynamicImageSkuColor": false,
        "isEditorial": false
      },
      "sellableDate": "2021-01-23 07:00:26",
      "isGroup": false,
      "hasMoreItems": false,
      "source": "REGULAR",
      "onlyXItemsLeftStockLevel": 3,
      "isFavorite": false
    },
    {
      "id": "prod152131304",
      "name": "Pinstriped Jacket",
      "displayable": true,
      "canonical": "/p/kiton-pinstriped-jacket-prod152131304",
      "designer": "Kiton",
      "cmosCatalog": "BGS20",
      "cmosItem": "B5ABG",
      "pimStyle": "3296076",
      "media": {
        "main": {
          "thumbnail": {
            "tag": "mnull"
          },
          "medium": {
            "url": "https://images.sample.com/ca/1/product_assets/B/5/A/B/G/BGB5ABG_ma.jpg",
            "tag": "ma"
          },
          "large": {
            "tag": "mnull"
          },
          "dynamic": {
            "url": "https://media.sample.com/images/f_auto,q_auto/01/3296076_m/kiton-",
            "tag": "m0"
          }
        },
        "alternate": {
          "a": {
            "thumbnail": {
              "tag": "anull"
            },
            "medium": {
              "url": "https://images.sample.com/ca/1/product_assets/B/5/A/B/G/BGB5ABG_aa.jpg",
              "tag": "aa"
            },
            "large": {
              "tag": "anull"
            },
            "dynamic": {
              "url": "https://media.sample.com/images/f_auto,q_auto/01/3296076_a/kiton-",
              "tag": "a0"
            }
          },
          "b": {
            "thumbnail": {
              "tag": "bnull"
            },
            "medium": {
              "url": "https://images.sample.com/ca/1/product_assets/B/5/A/B/G/BGB5ABG_ba.jpg",
              "tag": "ba"
            },
            "large": {
              "tag": "bnull"
            },
            "dynamic": {
              "url": "https://media.sample.com/images/f_auto,q_auto/01/3296076_b/kiton-",
              "tag": "b0"
            }
          },
          "c": {
            "thumbnail": {
              "tag": "cnull"
            },
            "medium": {
              "url": "https://images.sample.com/ca/1/product_assets/B/5/A/B/G/BGB5ABG_ca.jpg",
              "tag": "ca"
            },
            "large": {
              "tag": "cnull"
            },
            "dynamic": {
              "url": "https://media.sample.com/images/f_auto,q_auto/01/3296076_c/kiton-",
              "tag": "c0"
            }
          },
          "z": {
            "thumbnail": {
              "tag": "znull"
            },
            "medium": {
              "url": "https://images.sample.com/ca/1/product_assets/B/5/A/B/G/BGB5ABG_za.jpg",
              "tag": "za"
            },
            "large": {
              "tag": "znull"
            },
            "dynamic": {
              "url": "https://media.sample.com/images/f_auto,q_auto/01/3296076_z/kiton-",
              "tag": "z0"
            }
          }
        }
      },
      "price": {
        "currencyCode": "$",
        "retailPrice": "3925.00"
      },
      "preOrder": false,
      "productFlags": {
        "hasMoreColors": false,
        "isOnlyAtNM": false,
        "showMonogramLabel": false,
        "isNewArrival": false,
        "inLookBook": false,
        "dynamicImageSkuColor": false,
        "isEditorial": false
      },
      "sellableDate": "2021-02-11 07:00:19",
      "isGroup": false,
      "hasMoreItems": false,
      "source": "REGULAR",
      "onlyXItemsLeftStockLevel": 2,
      "isFavorite": false
    },
    {
      "id": "prod152131074",
      "name": "Checked Cashmere-Linen Blazer",
      "displayable": true,
      "canonical": "/p/kiton-checked-cashmere-linen-blazer-prod152131074",
      "designer": "Kiton",
      "cmosCatalog": "BGS20",
      "cmosItem": "B5A8W",
      "pimStyle": "3296073",
      "media": {
        "main": {
          "thumbnail": {
            "tag": "mnull"
          },
          "medium": {
            "url": "https://images.sample.com/ca/1/product_assets/B/5/A/8/W/BGB5A8W_ma.jpg",
            "tag": "ma"
          },
          "large": {
            "tag": "mnull"
          },
          "dynamic": {
            "url": "https://media.sample.com/images/f_auto,q_auto/01/3296073_m/kiton-",
            "tag": "m0"
          }
        },
        "alternate": {
          "a": {
            "thumbnail": {
              "tag": "anull"
            },
            "medium": {
              "url": "https://images.sample.com/ca/1/product_assets/B/5/A/8/W/BGB5A8W_aa.jpg",
              "tag": "aa"
            },
            "large": {
              "tag": "anull"
            },
            "dynamic": {
              "url": "https://media.sample.com/images/f_auto,q_auto/01/3296073_a/kiton-",
              "tag": "a0"
            }
          },
          "b": {
            "thumbnail": {
              "tag": "bnull"
            },
            "medium": {
              "url": "https://images.sample.com/ca/1/product_assets/B/5/A/8/W/BGB5A8W_ba.jpg",
              "tag": "ba"
            },
            "large": {
              "tag": "bnull"
            },
            "dynamic": {
              "url": "https://media.sample.com/images/f_auto,q_auto/01/3296073_b/kiton-",
              "tag": "b0"
            }
          },
          "c": {
            "thumbnail": {
              "tag": "cnull"
            },
            "medium": {
              "url": "https://images.sample.com/ca/1/product_assets/B/5/A/8/W/BGB5A8W_ca.jpg",
              "tag": "ca"
            },
            "large": {
              "tag": "cnull"
            },
            "dynamic": {
              "url": "https://media.sample.com/images/f_auto,q_auto/01/3296073_c/kiton-",
              "tag": "c0"
            }
          },
          "z": {
            "thumbnail": {
              "tag": "znull"
            },
            "medium": {
              "url": "https://images.sample.com/ca/1/product_assets/B/5/A/8/W/BGB5A8W_za.jpg",
              "tag": "za"
            },
            "large": {
              "tag": "znull"
            },
            "dynamic": {
              "url": "https://media.sample.com/images/f_auto,q_auto/01/3296073_z/kiton-",
              "tag": "z0"
            }
          }
        }
      },
      "price": {
        "currencyCode": "$",
        "retailPrice": "3790.00"
      },
      "preOrder": false,
      "productFlags": {
        "hasMoreColors": false,
        "isOnlyAtNM": false,
        "showMonogramLabel": false,
        "isNewArrival": false,
        "inLookBook": false,
        "dynamicImageSkuColor": false,
        "isEditorial": false
      },
      "sellableDate": "2021-01-14 07:00:25",
      "isGroup": false,
      "hasMoreItems": false,
      "source": "REGULAR",
      "onlyXItemsLeftStockLevel": 4,
      "isFavorite": false
    },
    {
      "id": "prod152131025",
      "name": "Crepe Belted Jacket",
      "displayable": true,
      "canonical": "/p/kiton-crepe-belted-jacket-prod152131025",
      "designer": "Kiton",
      "cmosCatalog": "BGS20",
      "cmosItem": "B5A74",
      "pimStyle": "3296068",
      "media": {
        "main": {
          "thumbnail": {
            "tag": "mnull"
          },
          "medium": {
            "url": "https://images.sample.com/ca/3/product_assets/B/5/A/7/4/BGB5A74_ma.jpg",
            "tag": "ma"
          },
          "large": {
            "tag": "mnull"
          },
          "dynamic": {
            "url": "https://media.sample.com/images/f_auto,q_auto/01/3296068_100550_m/kiton-crepe-belted-jacket",
            "tag": "m0"
          }
        },
        "alternate": {
          "a": {
            "thumbnail": {
              "tag": "anull"
            },
            "medium": {
              "url": "https://images.sample.com/ca/3/product_assets/B/5/A/7/4/BGB5A74_aa.jpg",
              "tag": "aa"
            },
            "large": {
              "tag": "anull"
            },
            "dynamic": {
              "url": "https://media.sample.com/images/f_auto,q_auto/01/3296068_100550_a/kiton-crepe-belted-jacket",
              "tag": "a0"
            }
          },
          "b": {
            "thumbnail": {
              "tag": "bnull"
            },
            "medium": {
              "url": "https://images.sample.com/ca/3/product_assets/B/5/A/7/4/BGB5A74_ba.jpg",
              "tag": "ba"
            },
            "large": {
              "tag": "bnull"
            },
            "dynamic": {
              "url": "https://media.sample.com/images/f_auto,q_auto/01/3296068_100550_b/kiton-crepe-belted-jacket",
              "tag": "b0"
            }
          },
          "c": {
            "thumbnail": {
              "tag": "cnull"
            },
            "medium": {
              "url": "https://images.sample.com/ca/3/product_assets/B/5/A/7/4/BGB5A74_ca.jpg",
              "tag": "ca"
            },
            "large": {
              "tag": "cnull"
            },
            "dynamic": {
              "url": "https://media.sample.com/images/f_auto,q_auto/01/3296068_100550_c/kiton-crepe-belted-jacket",
              "tag": "c0"
            }
          },
          "z": {
            "thumbnail": {
              "tag": "znull"
            },
            "medium": {
              "url": "https://images.sample.com/ca/2/product_assets/B/5/A/7/4/BGB5A74_za.jpg",
              "tag": "za"
            },
            "large": {
              "tag": "znull"
            },
            "dynamic": {
              "url": "https://media.sample.com/images/f_auto,q_auto/01/3296068_100550_z/kiton-crepe-belted-jacket",
              "tag": "z0"
            }
          }
        }
      },
      "price": {
        "currencyCode": "$",
        "retailPrice": "3760.00"
      },
      "preOrder": false,
      "productFlags": {
        "hasMoreColors": false,
        "isOnlyAtNM": false,
        "showMonogramLabel": false,
        "isNewArrival": false,
        "inLookBook": false,
        "dynamicImageSkuColor": false,
        "isEditorial": false
      },
      "sellableDate": "2021-01-23 07:00:26",
      "isGroup": false,
      "hasMoreItems": false,
      "source": "REGULAR",
      "onlyXItemsLeftStockLevel": 4,
      "isFavorite": false
    },
    {
      "id": "prod156540005",
      "name": "Brightside Knot Embroidered ",
      "displayable": true,
      "canonical": "/p/zimmermann-brightside-knot-embroidered-prod156540005",
      "designer": "Zimmermann",
      "cmosCatalog": "BGS20",
      "cmosItem": "T0A8Z",
      "pimStyle": "3394845",
      "media": {
        "main": {
          "thumbnail": {
            "tag": "mnull"
          },
          "medium": {
            "url": "https://images.sample.com/ca/3/product_assets/T/0/A/8/Z/BGT0A8Z_ma.jpg",
            "tag": "ma"
          },
          "large": {
            "tag": "mnull"
          },
          "dynamic": {
            "url": "https://media.sample.com/images/f_auto,q_auto/01/3394845_m/zimmermann-",
            "tag": "m0"
          }
        },
        "alternate": {
          "a": {
            "thumbnail": {
              "tag": "anull"
            },
            "medium": {
              "url": "https://images.sample.com/ca/3/product_assets/T/0/A/8/Z/BGT0A8Z_aa.jpg",
              "tag": "aa"
            },
            "large": {
              "tag": "anull"
            },
            "dynamic": {
              "url": "https://media.sample.com/images/f_auto,q_auto/01/3394845_a/zimmermann-",
              "tag": "a0"
            }
          },
          "b": {
            "thumbnail": {
              "tag": "bnull"
            },
            "medium": {
              "url": "https://images.sample.com/ca/3/product_assets/T/0/A/8/Z/BGT0A8Z_ba.jpg",
              "tag": "ba"
            },
            "large": {
              "tag": "bnull"
            },
            "dynamic": {
              "url": "https://media.sample.com/images/f_auto,q_auto/01/3394845_b/zimmermann-",
              "tag": "b0"
            }
          },
          "c": {
            "thumbnail": {
              "tag": "cnull"
            },
            "medium": {
              "url": "https://images.sample.com/ca/3/product_assets/T/0/A/8/Z/BGT0A8Z_ca.jpg",
              "tag": "ca"
            },
            "large": {
              "tag": "cnull"
            },
            "dynamic": {
              "url": "https://media.sample.com/images/f_auto,q_auto/01/3394845_c/zimmermann-",
              "tag": "c0"
            }
          },
          "z": {
            "thumbnail": {
              "tag": "znull"
            },
            "medium": {
              "url": "https://images.sample.com/ca/3/product_assets/T/0/A/8/Z/BGT0A8Z_za.jpg",
              "tag": "za"
            },
            "large": {
              "tag": "znull"
            },
            "dynamic": {
              "url": "https://media.sample.com/images/f_auto,q_auto/01/3394845_z/zimmermann-",
              "tag": "z0"
            }
          }
        }
      },
      "price": {
        "currencyCode": "$",
        "retailPrice": "3750.00"
      },
      "preOrder": true,
      "productFlags": {
        "hasMoreColors": false,
        "isOnlyAtNM": false,
        "showMonogramLabel": false,
        "isNewArrival": false,
        "inLookBook": false,
        "dynamicImageSkuColor": false,
        "isEditorial": false
      },
      "sellableDate": "2021-03-06 15:00:03",
      "isGroup": false,
      "hasMoreItems": false,
      "source": "REGULAR",
      "onlyXItemsLeftStockLevel": 0,
      "isFavorite": false
    },
    {
      "id": "prod152131018",
      "name": "Wool Jacket",
      "displayable": true,
      "canonical": "/p/kiton-wool-jacket-prod152131018",
      "designer": "Kiton",
      "cmosCatalog": "BGS20",
      "cmosItem": "B5A8K",
      "pimStyle": "3296079",
      "media": {
        "main": {
          "thumbnail": {
            "tag": "mnull"
          },
          "medium": {
            "url": "https://images.sample.com/ca/1/product_assets/B/5/A/8/K/BGB5A8K_ma.jpg",
            "tag": "ma"
          },
          "large": {
            "tag": "mnull"
          },
          "dynamic": {
            "url": "https://media.sample.com/images/f_auto,q_auto/01/3296079_m/kiton-",
            "tag": "m0"
          }
        },
        "alternate": {
          "a": {
            "thumbnail": {
              "tag": "anull"
            },
            "medium": {
              "url": "https://images.sample.com/ca/1/product_assets/B/5/A/8/K/BGB5A8K_aa.jpg",
              "tag": "aa"
            },
            "large": {
              "tag": "anull"
            },
            "dynamic": {
              "url": "https://media.sample.com/images/f_auto,q_auto/01/3296079_a/kiton-",
              "tag": "a0"
            }
          },
          "b": {
            "thumbnail": {
              "tag": "bnull"
            },
            "medium": {
              "url": "https://images.sample.com/ca/1/product_assets/B/5/A/8/K/BGB5A8K_ba.jpg",
              "tag": "ba"
            },
            "large": {
              "tag": "bnull"
            },
            "dynamic": {
              "url": "https://media.sample.com/images/f_auto,q_auto/01/3296079_b/kiton-",
              "tag": "b0"
            }
          },
          "c": {
            "thumbnail": {
              "tag": "cnull"
            },
            "medium": {
              "url": "https://images.sample.com/ca/1/product_assets/B/5/A/8/K/BGB5A8K_ca.jpg",
              "tag": "ca"
            },
            "large": {
              "tag": "cnull"
            },
            "dynamic": {
              "url": "https://media.sample.com/images/f_auto,q_auto/01/3296079_c/kiton-",
              "tag": "c0"
            }
          },
          "z": {
            "thumbnail": {
              "tag": "znull"
            },
            "medium": {
              "url": "https://images.sample.com/ca/1/product_assets/B/5/A/8/K/BGB5A8K_za.jpg",
              "tag": "za"
            },
            "large": {
              "tag": "znull"
            },
            "dynamic": {
              "url": "https://media.sample.com/images/f_auto,q_auto/01/3296079_z/kiton-",
              "tag": "z0"
            }
          }
        }
      },
      "price": {
        "currencyCode": "$",
        "retailPrice": "3615.00"
      },
      "preOrder": false,
      "productFlags": {
        "hasMoreColors": false,
        "isOnlyAtNM": false,
        "showMonogramLabel": false,
        "isNewArrival": false,
        "inLookBook": false,
        "dynamicImageSkuColor": false,
        "isEditorial": false
      },
      "sellableDate": "2019-12-31 07:00:18",
      "isGroup": false,
      "hasMoreItems": false,
      "source": "REGULAR",
      "onlyXItemsLeftStockLevel": 6,
      "isFavorite": false
    },
    {
      "id": "prod152131101",
      "name": "Double-Breasted Wool Blazer",
      "displayable": true,
      "canonical": "/p/kiton-double-breasted-wool-blazer-prod152131101",
      "designer": "Kiton",
      "cmosCatalog": "BGS20",
      "cmosItem": "B5A95",
      "pimStyle": "3296077",
      "media": {
        "main": {
          "thumbnail": {
            "tag": "mnull"
          },
          "medium": {
            "url": "https://images.sample.com/ca/1/product_assets/B/5/A/9/5/BGB5A95_ma.jpg",
            "tag": "ma"
          },
          "large": {
            "tag": "mnull"
          },
          "dynamic": {
            "url": "https://media.sample.com/images/f_auto,q_auto/01/3296077_m/kiton-",
            "tag": "m0"
          }
        },
        "alternate": {
          "a": {
            "thumbnail": {
              "tag": "anull"
            },
            "medium": {
              "url": "https://images.sample.com/ca/1/product_assets/B/5/A/9/5/BGB5A95_aa.jpg",
              "tag": "aa"
            },
            "large": {
              "tag": "anull"
            },
            "dynamic": {
              "url": "https://media.sample.com/images/f_auto,q_auto/01/3296077_a/kiton-",
              "tag": "a0"
            }
          },
          "b": {
            "thumbnail": {
              "tag": "bnull"
            },
            "medium": {
              "url": "https://images.sample.com/ca/1/product_assets/B/5/A/9/5/BGB5A95_ba.jpg",
              "tag": "ba"
            },
            "large": {
              "tag": "bnull"
            },
            "dynamic": {
              "url": "https://media.sample.com/images/f_auto,q_auto/01/3296077_b/kiton-",
              "tag": "b0"
            }
          },
          "c": {
            "thumbnail": {
              "tag": "cnull"
            },
            "medium": {
              "url": "https://images.sample.com/ca/1/product_assets/B/5/A/9/5/BGB5A95_ca.jpg",
              "tag": "ca"
            },
            "large": {
              "tag": "cnull"
            },
            "dynamic": {
              "url": "https://media.sample.com/images/f_auto,q_auto/01/3296077_c/kiton-",
              "tag": "c0"
            }
          },
          "z": {
            "thumbnail": {
              "tag": "znull"
            },
            "medium": {
              "url": "https://images.sample.com/ca/1/product_assets/B/5/A/9/5/BGB5A95_za.jpg",
              "tag": "za"
            },
            "large": {
              "tag": "znull"
            },
            "dynamic": {
              "url": "https://media.sample.com/images/f_auto,q_auto/01/3296077_z/kiton-",
              "tag": "z0"
            }
          }
        }
      },
      "price": {
        "currencyCode": "$",
        "retailPrice": "3530.00"
      },
      "preOrder": false,
      "productFlags": {
        "hasMoreColors": false,
        "isOnlyAtNM": false,
        "showMonogramLabel": false,
        "isNewArrival": false,
        "inLookBook": false,
        "dynamicImageSkuColor": false,
        "isEditorial": false
      },
      "sellableDate": "2021-01-16 07:00:24",
      "isGroup": false,
      "hasMoreItems": false,
      "source": "REGULAR",
      "onlyXItemsLeftStockLevel": 2,
      "isFavorite": false
    },
    {
      "id": "prod152140140",
      "name": "Wool-Silk Tailored Jacket",
      "displayable": true,
      "canonical": "/p/kiton-wool-silk-tailored-jacket-prod152140140",
      "designer": "Kiton",
      "cmosCatalog": "BGS20",
      "cmosItem": "B5A99",
      "pimStyle": "3296062",
      "media": {
        "main": {
          "thumbnail": {
            "tag": "mnull"
          },
          "medium": {
            "url": "https://images.sample.com/ca/1/product_assets/B/5/A/9/9/BGB5A99_ma.jpg",
            "tag": "ma"
          },
          "large": {
            "tag": "mnull"
          },
          "dynamic": {
            "url": "https://media.sample.com/images/f_auto,q_auto/01/3296062_m/kiton-",
            "tag": "m0"
          }
        },
        "alternate": {
          "a": {
            "thumbnail": {
              "tag": "anull"
            },
            "medium": {
              "url": "https://images.sample.com/ca/1/product_assets/B/5/A/9/9/BGB5A99_aa.jpg",
              "tag": "aa"
            },
            "large": {
              "tag": "anull"
            },
            "dynamic": {
              "url": "https://media.sample.com/images/f_auto,q_auto/01/3296062_a/kiton-",
              "tag": "a0"
            }
          },
          "b": {
            "thumbnail": {
              "tag": "bnull"
            },
            "medium": {
              "url": "https://images.sample.com/ca/1/product_assets/B/5/A/9/9/BGB5A99_ba.jpg",
              "tag": "ba"
            },
            "large": {
              "tag": "bnull"
            },
            "dynamic": {
              "url": "https://media.sample.com/images/f_auto,q_auto/01/3296062_b/kiton-",
              "tag": "b0"
            }
          },
          "c": {
            "thumbnail": {
              "tag": "cnull"
            },
            "medium": {
              "url": "https://images.sample.com/ca/1/product_assets/B/5/A/9/9/BGB5A99_ca.jpg",
              "tag": "ca"
            },
            "large": {
              "tag": "cnull"
            },
            "dynamic": {
              "url": "https://media.sample.com/images/f_auto,q_auto/01/3296062_c/kiton-",
              "tag": "c0"
            }
          },
          "z": {
            "thumbnail": {
              "tag": "znull"
            },
            "medium": {
              "url": "https://images.sample.com/ca/1/product_assets/B/5/A/9/9/BGB5A99_za.jpg",
              "tag": "za"
            },
            "large": {
              "tag": "znull"
            },
            "dynamic": {
              "url": "https://media.sample.com/images/f_auto,q_auto/01/3296062_z/kiton-",
              "tag": "z0"
            }
          }
        }
      },
      "price": {
        "currencyCode": "$",
        "retailPrice": "3495.00"
      },
      "preOrder": false,
      "productFlags": {
        "hasMoreColors": false,
        "isOnlyAtNM": false,
        "showMonogramLabel": false,
        "isNewArrival": false,
        "inLookBook": false,
        "dynamicImageSkuColor": false,
        "isEditorial": false
      },
      "sellableDate": "2021-02-07 07:00:20",
      "isGroup": false,
      "hasMoreItems": false,
      "source": "REGULAR",
      "onlyXItemsLeftStockLevel": 3,
      "isFavorite": false
    },
    {
      "id": "prod152910884",
      "name": "Isa Tiered Silk Embellished Dress",
      "displayable": true,
      "canonical": "/p/saloni-isa-tiered-silk-embellished-dress-prod152910884",
      "designer": "Saloni",
      "cmosCatalog": "BGS20",
      "cmosItem": "T03C2",
      "pimStyle": "3342298",
      "media": {
        "main": {
          "thumbnail": {
            "tag": "mnull"
          },
          "medium": {
            "url": "https://images.sample.com/ca/1/product_assets/T/0/3/C/2/BGT03C2_ma.jpg",
            "tag": "ma"
          },
          "large": {
            "tag": "mnull"
          },
          "dynamic": {
            "url": "https://media.sample.com/images/f_auto,q_auto/01/3342298_m/saloni-",
            "tag": "m0"
          }
        },
        "alternate": {
          "a": {
            "thumbnail": {
              "tag": "anull"
            },
            "medium": {
              "url": "https://images.sample.com/ca/1/product_assets/T/0/3/C/2/BGT03C2_aa.jpg",
              "tag": "aa"
            },
            "large": {
              "tag": "anull"
            },
            "dynamic": {
              "url": "https://media.sample.com/images/f_auto,q_auto/01/3342298_a/saloni-",
              "tag": "a0"
            }
          },
          "b": {
            "thumbnail": {
              "tag": "bnull"
            },
            "medium": {
              "url": "https://images.sample.com/ca/1/product_assets/T/0/3/C/2/BGT03C2_ba.jpg",
              "tag": "ba"
            },
            "large": {
              "tag": "bnull"
            },
            "dynamic": {
              "url": "https://media.sample.com/images/f_auto,q_auto/01/3342298_b/saloni-",
              "tag": "b0"
            }
          },
          "c": {
            "thumbnail": {
              "tag": "cnull"
            },
            "medium": {
              "url": "https://images.sample.com/ca/1/product_assets/T/0/3/C/2/BGT03C2_ca.jpg",
              "tag": "ca"
            },
            "large": {
              "tag": "cnull"
            },
            "dynamic": {
              "url": "https://media.sample.com/images/f_auto,q_auto/01/3342298_c/saloni-",
              "tag": "c0"
            }
          },
          "z": {
            "thumbnail": {
              "tag": "znull"
            },
            "medium": {
              "url": "https://images.sample.com/ca/1/product_assets/T/0/3/C/2/BGT03C2_za.jpg",
              "tag": "za"
            },
            "large": {
              "tag": "znull"
            },
            "dynamic": {
              "url": "https://media.sample.com/images/f_auto,q_auto/01/3342298_z/saloni-",
              "tag": "z0"
            }
          }
        }
      },
      "price": {
        "currencyCode": "$",
        "retailPrice": "2900.00"
      },
      "preOrder": false,
      "productFlags": {
        "hasMoreColors": false,
        "isOnlyAtNM": false,
        "showMonogramLabel": false,
        "isNewArrival": false,
        "inLookBook": false,
        "dynamicImageSkuColor": false,
        "isEditorial": false
      },
      "sellableDate": "2021-01-17 07:00:17",
      "isGroup": false,
      "hasMoreItems": false,
      "source": "REGULAR",
      "onlyXItemsLeftStockLevel": 1,
      "isFavorite": false
    },
    {
      "id": "prod151580118",
      "name": "Glitter Tulle Ruffle-Skirt A-Line Dress w/ Scarf Detail",
      "displayable": true,
      "canonical": "/p/redvalentino-glitter-tulle-ruffle-skirt-a-line-dress-w-scarf-detail-prod151580118",
      "designer": "REDValentino",
      "cmosCatalog": "BGS20",
      "cmosItem": "TZNZ4",
      "pimStyle": "3253270",
      "media": {
        "main": {
          "thumbnail": {
            "tag": "mnull"
          },
          "medium": {
            "url": "https://images.sample.com/ca/2/product_assets/T/Z/N/Z/4/BGTZNZ4_ma.jpg",
            "tag": "ma"
          },
          "large": {
            "tag": "mnull"
          },
          "dynamic": {
            "url": "https://media.sample.com/images/f_auto,q_auto/01/3253270_100323_m/redvalentino-glitter-tulle-dress",
            "tag": "m0"
          }
        },
        "alternate": {
          "a": {
            "thumbnail": {
              "tag": "anull"
            },
            "medium": {
              "url": "https://images.sample.com/ca/2/product_assets/T/Z/N/Z/4/BGTZNZ4_aa.jpg",
              "tag": "aa"
            },
            "large": {
              "tag": "anull"
            },
            "dynamic": {
              "url": "https://media.sample.com/images/f_auto,q_auto/01/3253270_100323_a/redvalentino-glitter-tulle-dress",
              "tag": "a0"
            }
          },
          "b": {
            "thumbnail": {
              "tag": "bnull"
            },
            "medium": {
              "url": "https://images.sample.com/ca/2/product_assets/T/Z/N/Z/4/BGTZNZ4_ba.jpg",
              "tag": "ba"
            },
            "large": {
              "tag": "bnull"
            },
            "dynamic": {
              "url": "https://media.sample.com/images/f_auto,q_auto/01/3253270_100323_b/redvalentino-glitter-tulle-dress",
              "tag": "b0"
            }
          },
          "c": {
            "thumbnail": {
              "tag": "cnull"
            },
            "medium": {
              "url": "https://images.sample.com/ca/2/product_assets/T/Z/N/Z/4/BGTZNZ4_ca.jpg",
              "tag": "ca"
            },
            "large": {
              "tag": "cnull"
            },
            "dynamic": {
              "url": "https://media.sample.com/images/f_auto,q_auto/01/3253270_100323_c/redvalentino-glitter-tulle-dress",
              "tag": "c0"
            }
          },
          "z": {
            "thumbnail": {
              "tag": "znull"
            },
            "medium": {
              "url": "https://images.sample.com/ca/2/product_assets/T/Z/N/Z/4/BGTZNZ4_za.jpg",
              "tag": "za"
            },
            "large": {
              "tag": "znull"
            },
            "dynamic": {
              "url": "https://media.sample.com/images/f_auto,q_auto/01/3253270_100323_z/redvalentino-glitter-tulle-dress",
              "tag": "z0"
            }
          }
        }
      },
      "price": {
        "currencyCode": "$",
        "retailPrice": "2825.00"
      },
      "preOrder": false,
      "productFlags": {
        "hasMoreColors": false,
        "isOnlyAtNM": false,
        "showMonogramLabel": false,
        "isNewArrival": false,
        "inLookBook": false,
        "dynamicImageSkuColor": false,
        "isEditorial": false
      },
      "sellableDate": "2019-11-01 18:00:04",
      "isGroup": false,
      "hasMoreItems": false,
      "source": "REGULAR",
      "onlyXItemsLeftStockLevel": 5,
      "isFavorite": false
    },
    {
      "id": "prod150580011",
      "name": "Greenwich Fox Fur Reversible Coat",
      "displayable": true,
      "canonical": "/p/nicole-benisti-greenwich-fox-fur-reversible-coat-prod150580011",
      "designer": "Nicole Benisti",
      "cmosCatalog": "BGS20",
      "cmosItem": "TZDZB",
      "pimStyle": "3202577",
      "media": {
        "main": {
          "thumbnail": {
            "tag": "mnull"
          },
          "medium": {
            "url": "https://images.sample.com/ca/2/product_assets/T/Z/D/Z/B/BGTZDZB_ma.jpg",
            "tag": "ma"
          },
          "large": {
            "tag": "mnull"
          },
          "dynamic": {
            "url": "https://media.sample.com/images/f_auto,q_auto/01/3202577_100106_m/nicole-benisti-fox-fur-reversible-coat",
            "tag": "m0"
          }
        },
        "alternate": {
          "a": {
            "thumbnail": {
              "tag": "anull"
            },
            "medium": {
              "url": "https://images.sample.com/ca/2/product_assets/T/Z/D/Z/B/BGTZDZB_aa.jpg",
              "tag": "aa"
            },
            "large": {
              "tag": "anull"
            },
            "dynamic": {
              "url": "https://media.sample.com/images/f_auto,q_auto/01/3202577_100106_a/nicole-benisti-fox-fur-reversible-coat",
              "tag": "a0"
            }
          },
          "b": {
            "thumbnail": {
              "tag": "bnull"
            },
            "medium": {
              "url": "https://images.sample.com/ca/2/product_assets/T/Z/D/Z/B/BGTZDZB_ba.jpg",
              "tag": "ba"
            },
            "large": {
              "tag": "bnull"
            },
            "dynamic": {
              "url": "https://media.sample.com/images/f_auto,q_auto/01/3202577_100106_b/nicole-benisti-fox-fur-reversible-coat",
              "tag": "b0"
            }
          },
          "c": {
            "thumbnail": {
              "tag": "cnull"
            },
            "medium": {
              "url": "https://images.sample.com/ca/2/product_assets/T/Z/D/Z/B/BGTZDZB_ca.jpg",
              "tag": "ca"
            },
            "large": {
              "tag": "cnull"
            },
            "dynamic": {
              "url": "https://media.sample.com/images/f_auto,q_auto/01/3202577_100106_c/nicole-benisti-fox-fur-reversible-coat",
              "tag": "c0"
            }
          },
          "z": {
            "thumbnail": {
              "tag": "znull"
            },
            "medium": {
              "url": "https://images.sample.com/ca/2/product_assets/T/Z/D/Z/B/BGTZDZB_za.jpg",
              "tag": "za"
            },
            "large": {
              "tag": "znull"
            },
            "dynamic": {
              "url": "https://media.sample.com/images/f_auto,q_auto/01/3202577_100106_z/nicole-benisti-fox-fur-reversible-coat",
              "tag": "z0"
            }
          }
        }
      },
      "price": {
        "currencyCode": "$",
        "retailPrice": "2800.00"
      },
      "preOrder": false,
      "productFlags": {
        "hasMoreColors": false,
        "isOnlyAtNM": false,
        "showMonogramLabel": false,
        "isNewArrival": false,
        "inLookBook": false,
        "dynamicImageSkuColor": false,
        "isEditorial": false
      },
      "sellableDate": "2019-10-31 07:00:15",
      "isGroup": false,
      "hasMoreItems": false,
      "source": "REGULAR",
      "onlyXItemsLeftStockLevel": 1,
      "isFavorite": false
    },
    {
      "id": "prod150570030",
      "name": "Gramercy Lamb Shearling Asymmetric-Zip Coat",
      "displayable": true,
      "canonical": "/p/nicole-benisti-gramercy-lamb-shearling-asymmetric-zip-coat-prod150570030",
      "designer": "Nicole Benisti",
      "cmosCatalog": "BGS20",
      "cmosItem": "TZDZG",
      "pimStyle": "3202575",
      "media": {
        "main": {
          "thumbnail": {
            "tag": "mnull"
          },
          "medium": {
            "url": "https://images.sample.com/ca/2/product_assets/T/Z/D/Z/G/BGTZDZG_ma.jpg",
            "tag": "ma"
          },
          "large": {
            "tag": "mnull"
          },
          "dynamic": {
            "url": "https://media.sample.com/images/f_auto,q_auto/01/3202575_100189_m/nicole-benisti-lamb-shearling-asym-zip-coat",
            "tag": "m0"
          }
        },
        "alternate": {
          "a": {
            "thumbnail": {
              "tag": "anull"
            },
            "medium": {
              "url": "https://images.sample.com/ca/2/product_assets/T/Z/D/Z/G/BGTZDZG_aa.jpg",
              "tag": "aa"
            },
            "large": {
              "tag": "anull"
            },
            "dynamic": {
              "url": "https://media.sample.com/images/f_auto,q_auto/01/3202575_100189_a/nicole-benisti-lamb-shearling-asym-zip-coat",
              "tag": "a0"
            }
          },
          "b": {
            "thumbnail": {
              "tag": "bnull"
            },
            "medium": {
              "url": "https://images.sample.com/ca/2/product_assets/T/Z/D/Z/G/BGTZDZG_ba.jpg",
              "tag": "ba"
            },
            "large": {
              "tag": "bnull"
            },
            "dynamic": {
              "url": "https://media.sample.com/images/f_auto,q_auto/01/3202575_100189_b/nicole-benisti-lamb-shearling-asym-zip-coat",
              "tag": "b0"
            }
          },
          "c": {
            "thumbnail": {
              "tag": "cnull"
            },
            "medium": {
              "url": "https://images.sample.com/ca/2/product_assets/T/Z/D/Z/G/BGTZDZG_ca.jpg",
              "tag": "ca"
            },
            "large": {
              "tag": "cnull"
            },
            "dynamic": {
              "url": "https://media.sample.com/images/f_auto,q_auto/01/3202575_100189_c/nicole-benisti-lamb-shearling-asym-zip-coat",
              "tag": "c0"
            }
          },
          "z": {
            "thumbnail": {
              "tag": "znull"
            },
            "medium": {
              "url": "https://images.sample.com/ca/2/product_assets/T/Z/D/Z/G/BGTZDZG_za.jpg",
              "tag": "za"
            },
            "large": {
              "tag": "znull"
            },
            "dynamic": {
              "url": "https://media.sample.com/images/f_auto,q_auto/01/3202575_100189_z/nicole-benisti-lamb-shearling-asym-zip-coat",
              "tag": "z0"
            }
          }
        }
      },
      "price": {
        "currencyCode": "$",
        "retailPrice": "2800.00"
      },
      "preOrder": false,
      "productFlags": {
        "hasMoreColors": false,
        "isOnlyAtNM": false,
        "showMonogramLabel": false,
        "isNewArrival": false,
        "inLookBook": false,
        "dynamicImageSkuColor": false,
        "isEditorial": false
      },
      "sellableDate": "2019-10-25 07:00:16",
      "isGroup": false,
      "hasMoreItems": false,
      "source": "REGULAR",
      "onlyXItemsLeftStockLevel": 1,
      "isFavorite": false
    },
    {
      "id": "prod153810140",
      "name": "Leather Trench Coat",
      "displayable": true,
      "canonical": "/p/frame-leather-trench-coat-prod153810140",
      "designer": "FRAME",
      "cmosCatalog": "BGS20",
      "cmosItem": "T0A1L",
      "pimStyle": "3385004",
      "media": {
        "main": {
          "thumbnail": {
            "tag": "mnull"
          },
          "medium": {
            "url": "https://images.sample.com/ca/1/product_assets/T/0/A/1/L/BGT0A1L_ma.jpg",
            "tag": "ma"
          },
          "large": {
            "tag": "mnull"
          },
          "dynamic": {
            "url": "https://media.sample.com/images/f_auto,q_auto/01/3385004_m/frame-",
            "tag": "m0"
          }
        },
        "alternate": {
          "a": {
            "thumbnail": {
              "tag": "anull"
            },
            "medium": {
              "url": "https://images.sample.com/ca/1/product_assets/T/0/A/1/L/BGT0A1L_aa.jpg",
              "tag": "aa"
            },
            "large": {
              "tag": "anull"
            },
            "dynamic": {
              "url": "https://media.sample.com/images/f_auto,q_auto/01/3385004_a/frame-",
              "tag": "a0"
            }
          },
          "b": {
            "thumbnail": {
              "tag": "bnull"
            },
            "medium": {
              "url": "https://images.sample.com/ca/1/product_assets/T/0/A/1/L/BGT0A1L_ba.jpg",
              "tag": "ba"
            },
            "large": {
              "tag": "bnull"
            },
            "dynamic": {
              "url": "https://media.sample.com/images/f_auto,q_auto/01/3385004_b/frame-",
              "tag": "b0"
            }
          },
          "c": {
            "thumbnail": {
              "tag": "cnull"
            },
            "medium": {
              "url": "https://images.sample.com/ca/1/product_assets/T/0/A/1/L/BGT0A1L_ca.jpg",
              "tag": "ca"
            },
            "large": {
              "tag": "cnull"
            },
            "dynamic": {
              "url": "https://media.sample.com/images/f_auto,q_auto/01/3385004_c/frame-",
              "tag": "c0"
            }
          },
          "z": {
            "thumbnail": {
              "tag": "znull"
            },
            "medium": {
              "url": "https://images.sample.com/ca/1/product_assets/T/0/A/1/L/BGT0A1L_za.jpg",
              "tag": "za"
            },
            "large": {
              "tag": "znull"
            },
            "dynamic": {
              "url": "https://media.sample.com/images/f_auto,q_auto/01/3385004_z/frame-",
              "tag": "z0"
            }
          }
        }
      },
      "price": {
        "currencyCode": "$",
        "retailPrice": "2495.00"
      },
      "preOrder": false,
      "productFlags": {
        "hasMoreColors": false,
        "isOnlyAtNM": false,
        "showMonogramLabel": false,
        "isNewArrival": false,
        "inLookBook": false,
        "dynamicImageSkuColor": false,
        "isEditorial": false
      },
      "sellableDate": "2021-01-06 18:00:04",
      "isGroup": false,
      "hasMoreItems": false,
      "source": "REGULAR",
      "onlyXItemsLeftStockLevel": 3,
      "isFavorite": false
    },
    {
      "id": "prod151590072",
      "name": "Leather Pleated Back Moto Jacket",
      "displayable": true,
      "canonical": "/p/redvalentino-leather-pleated-back-moto-jacket-prod151590072",
      "designer": "REDValentino",
      "cmosCatalog": "BGS20",
      "cmosItem": "TZHYK",
      "pimStyle": "3219664",
      "media": {
        "main": {
          "thumbnail": {
            "tag": "mnull"
          },
          "medium": {
            "url": "https://images.sample.com/ca/3/product_assets/T/Z/H/Y/K/BGTZHYK_ma.jpg",
            "tag": "ma"
          },
          "large": {
            "tag": "mnull"
          },
          "dynamic": {
            "url": "https://media.sample.com/images/f_auto,q_auto/01/3219664_100106_m/redvalentino-leather-pleated-back-moto-ja",
            "tag": "m0"
          }
        },
        "alternate": {
          "a": {
            "thumbnail": {
              "tag": "anull"
            },
            "medium": {
              "url": "https://images.sample.com/ca/3/product_assets/T/Z/H/Y/K/BGTZHYK_aa.jpg",
              "tag": "aa"
            },
            "large": {
              "tag": "anull"
            },
            "dynamic": {
              "url": "https://media.sample.com/images/f_auto,q_auto/01/3219664_100106_a/redvalentino-leather-pleated-back-moto-ja",
              "tag": "a0"
            }
          },
          "b": {
            "thumbnail": {
              "tag": "bnull"
            },
            "medium": {
              "url": "https://images.sample.com/ca/3/product_assets/T/Z/H/Y/K/BGTZHYK_ba.jpg",
              "tag": "ba"
            },
            "large": {
              "tag": "bnull"
            },
            "dynamic": {
              "url": "https://media.sample.com/images/f_auto,q_auto/01/3219664_100106_b/redvalentino-leather-pleated-back-moto-ja",
              "tag": "b0"
            }
          },
          "c": {
            "thumbnail": {
              "tag": "cnull"
            },
            "medium": {
              "url": "https://images.sample.com/ca/3/product_assets/T/Z/H/Y/K/BGTZHYK_ca.jpg",
              "tag": "ca"
            },
            "large": {
              "tag": "cnull"
            },
            "dynamic": {
              "url": "https://media.sample.com/images/f_auto,q_auto/01/3219664_100106_c/redvalentino-leather-pleated-back-moto-ja",
              "tag": "c0"
            }
          }
        }
      },
      "price": {
        "currencyCode": "$",
        "retailPrice": "2495.00"
      },
      "preOrder": false,
      "productFlags": {
        "hasMoreColors": false,
        "isOnlyAtNM": false,
        "showMonogramLabel": false,
        "isNewArrival": false,
        "inLookBook": false,
        "dynamicImageSkuColor": false,
        "isEditorial": false
      },
      "sellableDate": "2019-10-18 15:00:04",
      "isGroup": false,
      "hasMoreItems": false,
      "source": "REGULAR",
      "onlyXItemsLeftStockLevel": 4,
      "isFavorite": false
    },
    {
      "id": "prod151020072",
      "name": "Belted Leather Double-Breasted Trench Coat",
      "displayable": true,
      "canonical": "/p/frame-belted-leather-double-breasted-trench-coat-prod151020072",
      "designer": "FRAME",
      "cmosCatalog": "BGS20",
      "cmosItem": "TZJNM",
      "pimStyle": "3227119",
      "media": {
        "main": {
          "thumbnail": {
            "tag": "mnull"
          },
          "medium": {
            "url": "https://images.sample.com/ca/3/product_assets/T/Z/J/N/M/BGTZJNM_ma.jpg",
            "tag": "ma"
          },
          "large": {
            "tag": "mnull"
          },
          "dynamic": {
            "url": "https://media.sample.com/images/f_auto,q_auto/01/3227119_100105_m/frame-belted-leather-trench-coat",
            "tag": "m0"
          }
        },
        "alternate": {
          "a": {
            "thumbnail": {
              "tag": "anull"
            },
            "medium": {
              "url": "https://images.sample.com/ca/3/product_assets/T/Z/J/N/M/BGTZJNM_aa.jpg",
              "tag": "aa"
            },
            "large": {
              "tag": "anull"
            },
            "dynamic": {
              "url": "https://media.sample.com/images/f_auto,q_auto/01/3227119_100105_a/frame-belted-leather-trench-coat",
              "tag": "a0"
            }
          },
          "b": {
            "thumbnail": {
              "tag": "bnull"
            },
            "medium": {
              "url": "https://images.sample.com/ca/3/product_assets/T/Z/J/N/M/BGTZJNM_ba.jpg",
              "tag": "ba"
            },
            "large": {
              "tag": "bnull"
            },
            "dynamic": {
              "url": "https://media.sample.com/images/f_auto,q_auto/01/3227119_100105_b/frame-belted-leather-trench-coat",
              "tag": "b0"
            }
          },
          "c": {
            "thumbnail": {
              "tag": "cnull"
            },
            "medium": {
              "url": "https://images.sample.com/ca/3/product_assets/T/Z/J/N/M/BGTZJNM_ca.jpg",
              "tag": "ca"
            },
            "large": {
              "tag": "cnull"
            },
            "dynamic": {
              "url": "https://media.sample.com/images/f_auto,q_auto/01/3227119_100105_c/frame-belted-leather-trench-coat",
              "tag": "c0"
            }
          },
          "z": {
            "thumbnail": {
              "tag": "znull"
            },
            "medium": {
              "url": "https://images.sample.com/ca/3/product_assets/T/Z/J/N/M/BGTZJNM_za.jpg",
              "tag": "za"
            },
            "large": {
              "tag": "znull"
            },
            "dynamic": {
              "url": "https://media.sample.com/images/f_auto,q_auto/01/3227119_100105_z/frame-belted-leather-trench-coat",
              "tag": "z0"
            }
          }
        }
      },
      "price": {
        "currencyCode": "$",
        "retailPrice": "2495.00"
      },
      "preOrder": false,
      "productFlags": {
        "hasMoreColors": false,
        "isOnlyAtNM": false,
        "showMonogramLabel": false,
        "isNewArrival": false,
        "inLookBook": false,
        "dynamicImageSkuColor": false,
        "isEditorial": false
      },
      "sellableDate": "2019-10-01 07:00:15",
      "isGroup": false,
      "hasMoreItems": false,
      "source": "REGULAR",
      "onlyXItemsLeftStockLevel": 1,
      "isFavorite": false
    },
    {
      "id": "prod118890189",
      "name": "Fox Fur-Trimmed Cashmere U-Cape",
      "displayable": true,
      "canonical": "/p/sofia-cashmere-fox-fur-trimmed-cashmere-u-cape-prod118890189",
      "designer": "Sofia Cashmere",
      "cmosCatalog": "BGS20",
      "cmosItem": "D18KH",
      "pimStyle": "138964",
      "media": {
        "main": {
          "thumbnail": {
            "tag": "mnull"
          },
          "medium": {
            "url": "https://images.sample.com/ca/5/product_assets/D/1/8/K/H/BGD18KH_ma.jpg",
            "tag": "ma"
          },
          "large": {
            "tag": "mnull"
          },
          "dynamic": {
            "url": "https://media.sample.com/images/f_auto,q_auto/00/138964_m/sofia-cashmere-fox-fur-trim-cashmere-u-cape",
            "tag": "m0"
          }
        },
        "alternate": {
          "a": {
            "thumbnail": {
              "tag": "anull"
            },
            "medium": {
              "url": "https://images.sample.com/ca/5/product_assets/D/1/8/K/H/BGD18KH_aa.jpg",
              "tag": "aa"
            },
            "large": {
              "tag": "anull"
            },
            "dynamic": {
              "url": "https://media.sample.com/images/f_auto,q_auto/00/138964_a/sofia-cashmere-fox-fur-trim-cashmere-u-cape",
              "tag": "a0"
            }
          },
          "c": {
            "thumbnail": {
              "tag": "cnull"
            },
            "medium": {
              "url": "https://images.sample.com/ca/3/product_assets/D/1/8/K/H/BGD18KH_ca.jpg",
              "tag": "ca"
            },
            "large": {
              "tag": "cnull"
            },
            "dynamic": {
              "url": "https://media.sample.com/images/f_auto,q_auto/01/138964_c/sofia-cashmere-fox-fur-trim-cashmere-u-cape",
              "tag": "c0"
            }
          }
        }
      },
      "price": {
        "currencyCode": "$",
        "retailPrice": "2495.00"
      },
      "preOrder": false,
      "productFlags": {
        "hasMoreColors": false,
        "isOnlyAtNM": false,
        "showMonogramLabel": false,
        "isNewArrival": false,
        "inLookBook": false,
        "dynamicImageSkuColor": true,
        "isEditorial": false
      },
      "sellableDate": "2016-02-23 00:00:00",
      "isGroup": false,
      "hasMoreItems": false,
      "source": "REGULAR",
      "onlyXItemsLeftStockLevel": 2,
      "isFavorite": false
    },
    {
      "id": "prod151490027",
      "name": "Alpaca A-Line Classic Coat",
      "displayable": true,
      "canonical": "/p/jane-post-alpaca-a-line-classic-coat-prod151490027",
      "designer": "Jane Post",
      "cmosCatalog": "BGS20",
      "cmosItem": "TZMRA",
      "pimStyle": "3248900",
      "media": {
        "main": {
          "thumbnail": {
            "tag": "mnull"
          },
          "medium": {
            "url": "https://images.sample.com/ca/7/product_assets/T/Z/M/R/A/BGTZMRA_ma.jpg",
            "tag": "ma"
          },
          "large": {
            "tag": "mnull"
          },
          "dynamic": {
            "url": "https://media.sample.com/images/f_auto,q_auto/01/3248900_m/jane-post-alpaca-a-line-classic-coat",
            "tag": "m0"
          }
        },
        "alternate": {
          "a": {
            "thumbnail": {
              "tag": "anull"
            },
            "medium": {
              "url": "https://images.sample.com/ca/7/product_assets/T/Z/M/R/A/BGTZMRA_aa.jpg",
              "tag": "aa"
            },
            "large": {
              "tag": "anull"
            },
            "dynamic": {
              "url": "https://media.sample.com/images/f_auto,q_auto/01/3248900_a/jane-post-alpaca-a-line-classic-coat",
              "tag": "a0"
            }
          },
          "b": {
            "thumbnail": {
              "tag": "bnull"
            },
            "medium": {
              "url": "https://images.sample.com/ca/7/product_assets/T/Z/M/R/A/BGTZMRA_ba.jpg",
              "tag": "ba"
            },
            "large": {
              "tag": "bnull"
            },
            "dynamic": {
              "url": "https://media.sample.com/images/f_auto,q_auto/01/3248900_b/jane-post-alpaca-a-line-classic-coat",
              "tag": "b0"
            }
          },
          "c": {
            "thumbnail": {
              "tag": "cnull"
            },
            "medium": {
              "url": "https://images.sample.com/ca/5/product_assets/T/Z/M/R/A/BGTZMRA_ca.jpg",
              "tag": "ca"
            },
            "large": {
              "tag": "cnull"
            },
            "dynamic": {
              "url": "https://media.sample.com/images/f_auto,q_auto/01/3248900_c/jane-post-alpaca-a-line-classic-coat",
              "tag": "c0"
            }
          },
          "z": {
            "thumbnail": {
              "tag": "znull"
            },
            "medium": {
              "url": "https://images.sample.com/ca/5/product_assets/T/Z/M/R/A/BGTZMRA_za.jpg",
              "tag": "za"
            },
            "large": {
              "tag": "znull"
            },
            "dynamic": {
              "url": "https://media.sample.com/images/f_auto,q_auto/01/3248900_z/jane-post-alpaca-a-line-classic-coat",
              "tag": "z0"
            }
          }
        }
      },
      "price": {
        "currencyCode": "$",
        "retailPrice": "2400.00"
      },
      "preOrder": false,
      "productFlags": {
        "hasMoreColors": false,
        "isOnlyAtNM": false,
        "showMonogramLabel": false,
        "isNewArrival": false,
        "inLookBook": false,
        "dynamicImageSkuColor": true,
        "isEditorial": false
      },
      "sellableDate": "2019-09-20 18:00:09",
      "isGroup": false,
      "hasMoreItems": false,
      "source": "REGULAR",
      "onlyXItemsLeftStockLevel": 1,
      "isFavorite": false
    },
    {
      "id": "prod151490052",
      "name": "Cashmere A-Line Button-Front Coat",
      "displayable": true,
      "canonical": "/p/jane-post-cashmere-a-line-button-front-coat-prod151490052",
      "designer": "Jane Post",
      "cmosCatalog": "BGS20",
      "cmosItem": "TZMR8",
      "pimStyle": "3248898",
      "media": {
        "main": {
          "thumbnail": {
            "tag": "mnull"
          },
          "medium": {
            "url": "https://images.sample.com/ca/5/product_assets/T/Z/M/R/8/BGTZMR8_ma.jpg",
            "tag": "ma"
          },
          "large": {
            "tag": "mnull"
          },
          "dynamic": {
            "url": "https://media.sample.com/images/f_auto,q_auto/01/3248898_m/jane-post-cashmere-a-line-classic-coat",
            "tag": "m0"
          }
        },
        "alternate": {
          "a": {
            "thumbnail": {
              "tag": "anull"
            },
            "medium": {
              "url": "https://images.sample.com/ca/5/product_assets/T/Z/M/R/8/BGTZMR8_aa.jpg",
              "tag": "aa"
            },
            "large": {
              "tag": "anull"
            },
            "dynamic": {
              "url": "https://media.sample.com/images/f_auto,q_auto/01/3248898_a/jane-post-cashmere-a-line-classic-coat",
              "tag": "a0"
            }
          },
          "b": {
            "thumbnail": {
              "tag": "bnull"
            },
            "medium": {
              "url": "https://images.sample.com/ca/5/product_assets/T/Z/M/R/8/BGTZMR8_ba.jpg",
              "tag": "ba"
            },
            "large": {
              "tag": "bnull"
            },
            "dynamic": {
              "url": "https://media.sample.com/images/f_auto,q_auto/01/3248898_b/jane-post-cashmere-a-line-classic-coat",
              "tag": "b0"
            }
          }
        }
      },
      "price": {
        "currencyCode": "$",
        "retailPrice": "2400.00"
      },
      "preOrder": false,
      "productFlags": {
        "hasMoreColors": true,
        "isOnlyAtNM": false,
        "showMonogramLabel": false,
        "isNewArrival": false,
        "inLookBook": false,
        "dynamicImageSkuColor": true,
        "isEditorial": false
      },
      "sellableDate": "2019-09-20 18:00:09",
      "isGroup": false,
      "hasMoreItems": false,
      "source": "REGULAR",
      "onlyXItemsLeftStockLevel": 15,
      "isFavorite": false
    },
    {
      "id": "prod151490045",
      "name": "Cashmere Bal Coat",
      "displayable": true,
      "canonical": "/p/jane-post-cashmere-bal-coat-prod151490045",
      "designer": "Jane Post",
      "cmosCatalog": "BGS20",
      "cmosItem": "TZMR9",
      "pimStyle": "3248899",
      "media": {
        "main": {
          "thumbnail": {
            "tag": "mnull"
          },
          "medium": {
            "url": "https://images.sample.com/ca/4/product_assets/T/Z/M/R/9/BGTZMR9_ma.jpg",
            "tag": "ma"
          },
          "large": {
            "tag": "mnull"
          },
          "dynamic": {
            "url": "https://media.sample.com/image/upload/b_rgb:e9eaeb/f_auto,q_auto/01/3248899_100106_m",
            "tag": "m0"
          }
        },
        "alternate": {
          "a": {
            "thumbnail": {
              "tag": "anull"
            },
            "medium": {
              "url": "https://images.sample.com/ca/4/product_assets/T/Z/M/R/9/BGTZMR9_aa.jpg",
              "tag": "aa"
            },
            "large": {
              "tag": "anull"
            },
            "dynamic": {
              "url": "https://media.sample.com/images/f_auto,q_auto/01/3248899_100106_a/jane-post-cashmere-bal-coat",
              "tag": "a0"
            }
          },
          "b": {
            "thumbnail": {
              "tag": "bnull"
            },
            "medium": {
              "url": "https://images.sample.com/ca/4/product_assets/T/Z/M/R/9/BGTZMR9_ba.jpg",
              "tag": "ba"
            },
            "large": {
              "tag": "bnull"
            },
            "dynamic": {
              "url": "https://media.sample.com/images/f_auto,q_auto/01/3248899_100106_b/jane-post-cashmere-bal-coat",
              "tag": "b0"
            }
          }
        }
      },
      "price": {
        "currencyCode": "$",
        "retailPrice": "2400.00"
      },
      "preOrder": false,
      "productFlags": {
        "hasMoreColors": false,
        "isOnlyAtNM": false,
        "showMonogramLabel": false,
        "isNewArrival": false,
        "inLookBook": false,
        "dynamicImageSkuColor": false,
        "isEditorial": false
      },
      "sellableDate": "2019-09-13 07:00:18",
      "isGroup": false,
      "hasMoreItems": false,
      "source": "REGULAR",
      "onlyXItemsLeftStockLevel": 1,
      "isFavorite": false
    },
    {
      "id": "prod150570026",
      "name": "Belleville Solid Fur Trimmed & Lined Coat",
      "displayable": true,
      "canonical": "/p/nicole-benisti-belleville-solid-fur-trimmed-lined-coat-prod150570026",
      "designer": "Nicole Benisti",
      "cmosCatalog": "BGS20",
      "cmosItem": "TZDZ2",
      "pimStyle": "3202574",
      "media": {
        "main": {
          "thumbnail": {
            "tag": "mnull"
          },
          "medium": {
            "url": "https://images.sample.com/ca/2/product_assets/T/Z/D/Z/2/BGTZDZ2_ma.jpg",
            "tag": "ma"
          },
          "large": {
            "tag": "mnull"
          },
          "dynamic": {
            "url": "https://media.sample.com/images/f_auto,q_auto/01/3202574_100131_m/nicole-benisti-solid-fur-trim-lined-coat",
            "tag": "m0"
          }
        },
        "alternate": {
          "a": {
            "thumbnail": {
              "tag": "anull"
            },
            "medium": {
              "url": "https://images.sample.com/ca/2/product_assets/T/Z/D/Z/2/BGTZDZ2_aa.jpg",
              "tag": "aa"
            },
            "large": {
              "tag": "anull"
            },
            "dynamic": {
              "url": "https://media.sample.com/images/f_auto,q_auto/01/3202574_100131_a/nicole-benisti-solid-fur-trim-lined-coat",
              "tag": "a0"
            }
          },
          "b": {
            "thumbnail": {
              "tag": "bnull"
            },
            "medium": {
              "url": "https://images.sample.com/ca/2/product_assets/T/Z/D/Z/2/BGTZDZ2_ba.jpg",
              "tag": "ba"
            },
            "large": {
              "tag": "bnull"
            },
            "dynamic": {
              "url": "https://media.sample.com/images/f_auto,q_auto/01/3202574_100131_b/nicole-benisti-solid-fur-trim-lined-coat",
              "tag": "b0"
            }
          },
          "c": {
            "thumbnail": {
              "tag": "cnull"
            },
            "medium": {
              "url": "https://images.sample.com/ca/2/product_assets/T/Z/D/Z/2/BGTZDZ2_ca.jpg",
              "tag": "ca"
            },
            "large": {
              "tag": "cnull"
            },
            "dynamic": {
              "url": "https://media.sample.com/images/f_auto,q_auto/01/3202574_100131_c/nicole-benisti-solid-fur-trim-lined-coat",
              "tag": "c0"
            }
          },
          "z": {
            "thumbnail": {
              "tag": "znull"
            },
            "medium": {
              "url": "https://images.sample.com/ca/2/product_assets/T/Z/D/Z/2/BGTZDZ2_za.jpg",
              "tag": "za"
            },
            "large": {
              "tag": "znull"
            },
            "dynamic": {
              "url": "https://media.sample.com/images/f_auto,q_auto/01/3202574_100131_z/nicole-benisti-solid-fur-trim-lined-coat",
              "tag": "z0"
            }
          }
        }
      },
      "price": {
        "currencyCode": "$",
        "retailPrice": "2200.00"
      },
      "preOrder": false,
      "productFlags": {
        "hasMoreColors": false,
        "isOnlyAtNM": false,
        "showMonogramLabel": false,
        "isNewArrival": false,
        "inLookBook": false,
        "dynamicImageSkuColor": false,
        "isEditorial": false
      },
      "sellableDate": "2019-10-24 07:00:16",
      "isGroup": false,
      "hasMoreItems": false,
      "source": "REGULAR",
      "onlyXItemsLeftStockLevel": 3,
      "isFavorite": false
    },
    {
      "id": "prod153960180",
      "name": "Double-Face Leather Trench Coat",
      "displayable": true,
      "canonical": "/p/vince-double-face-leather-trench-coat-prod153960180",
      "designer": "Vince",
      "cmosCatalog": "BGS20",
      "cmosItem": "T0BQ0",
      "pimStyle": "3398449",
      "media": {
        "main": {
          "thumbnail": {
            "tag": "mnull"
          },
          "medium": {
            "url": "https://images.sample.com/ca/3/product_assets/T/0/B/Q/0/BGT0BQ0_ma.jpg",
            "tag": "ma"
          },
          "large": {
            "tag": "mnull"
          },
          "dynamic": {
            "url": "https://media.sample.com/images/f_auto,q_auto/01/3398449_100296_m/vince-dbl-face-leather-trench",
            "tag": "m0"
          }
        },
        "alternate": {
          "a": {
            "thumbnail": {
              "tag": "anull"
            },
            "medium": {
              "url": "https://images.sample.com/ca/3/product_assets/T/0/B/Q/0/BGT0BQ0_aa.jpg",
              "tag": "aa"
            },
            "large": {
              "tag": "anull"
            },
            "dynamic": {
              "url": "https://media.sample.com/images/f_auto,q_auto/01/3398449_100296_a/vince-dbl-face-leather-trench",
              "tag": "a0"
            }
          },
          "b": {
            "thumbnail": {
              "tag": "bnull"
            },
            "medium": {
              "url": "https://images.sample.com/ca/3/product_assets/T/0/B/Q/0/BGT0BQ0_ba.jpg",
              "tag": "ba"
            },
            "large": {
              "tag": "bnull"
            },
            "dynamic": {
              "url": "https://media.sample.com/images/f_auto,q_auto/01/3398449_100296_b/vince-dbl-face-leather-trench",
              "tag": "b0"
            }
          },
          "c": {
            "thumbnail": {
              "tag": "cnull"
            },
            "medium": {
              "url": "https://images.sample.com/ca/3/product_assets/T/0/B/Q/0/BGT0BQ0_ca.jpg",
              "tag": "ca"
            },
            "large": {
              "tag": "cnull"
            },
            "dynamic": {
              "url": "https://media.sample.com/images/f_auto,q_auto/01/3398449_100296_c/vince-dbl-face-leather-trench",
              "tag": "c0"
            }
          },
          "z": {
            "thumbnail": {
              "tag": "znull"
            },
            "medium": {
              "url": "https://images.sample.com/ca/2/product_assets/T/0/B/Q/0/BGT0BQ0_za.jpg",
              "tag": "za"
            },
            "large": {
              "tag": "znull"
            },
            "dynamic": {
              "url": "https://media.sample.com/images/f_auto,q_auto/01/3398449_100296_z/vince-dbl-face-leather-trench",
              "tag": "z0"
            }
          }
        }
      },
      "price": {
        "currencyCode": "$",
        "retailPrice": "2195.00"
      },
      "preOrder": false,
      "productFlags": {
        "hasMoreColors": false,
        "isOnlyAtNM": false,
        "showMonogramLabel": false,
        "isNewArrival": false,
        "inLookBook": false,
        "dynamicImageSkuColor": false,
        "isEditorial": false
      },
      "sellableDate": "2019-12-06 15:00:04",
      "isGroup": false,
      "hasMoreItems": false,
      "source": "REGULAR",
      "onlyXItemsLeftStockLevel": 10,
      "isFavorite": false
    },
    {
      "id": "prod147540223",
      "name": "Sleeveless Crepe Sheath Dress",
      "displayable": true,
      "canonical": "/p/kiton-sleeveless-crepe-sheath-dress-prod147540223",
      "designer": "Kiton",
      "cmosCatalog": "BGS20",
      "cmosItem": "B4YNB",
      "pimStyle": "3072879",
      "media": {
        "main": {
          "thumbnail": {
            "tag": "mnull"
          },
          "medium": {
            "url": "https://images.sample.com/ca/4/product_assets/B/4/Y/N/B/BGB4YNB_ma.jpg",
            "tag": "ma"
          },
          "large": {
            "tag": "mnull"
          },
          "dynamic": {
            "url": "https://media.sample.com/image/upload/b_rgb:e9eaeb/f_auto,q_auto/01/3072879_100106_m",
            "tag": "m0"
          }
        },
        "alternate": {
          "a": {
            "thumbnail": {
              "tag": "anull"
            },
            "medium": {
              "url": "https://images.sample.com/ca/4/product_assets/B/4/Y/N/B/BGB4YNB_aa.jpg",
              "tag": "aa"
            },
            "large": {
              "tag": "anull"
            },
            "dynamic": {
              "url": "https://media.sample.com/images/f_auto,q_auto/01/3072879_100106_a/kiton-crepe-sheath-dress",
              "tag": "a0"
            }
          }
        }
      },
      "price": {
        "currencyCode": "$",
        "retailPrice": "2185.00"
      },
      "preOrder": false,
      "productFlags": {
        "hasMoreColors": false,
        "isOnlyAtNM": false,
        "showMonogramLabel": false,
        "isNewArrival": false,
        "inLookBook": false,
        "dynamicImageSkuColor": false,
        "isEditorial": false
      },
      "sellableDate": "2019-08-02 07:00:18",
      "isGroup": false,
      "hasMoreItems": false,
      "source": "REGULAR",
      "onlyXItemsLeftStockLevel": 1,
      "isFavorite": false
    },
    {
      "id": "prod151320057",
      "name": "Mink-Front Belted Sheepskin Coat",
      "displayable": true,
      "canonical": "/p/blancha-mink-front-belted-sheepskin-coat-prod151320057",
      "designer": "Blancha",
      "cmosCatalog": "BGS20",
      "cmosItem": "TZLD8",
      "pimStyle": "3240244",
      "media": {
        "main": {
          "thumbnail": {
            "tag": "mnull"
          },
          "medium": {
            "url": "https://images.sample.com/ca/4/product_assets/T/Z/L/D/8/BGTZLD8_ma.jpg",
            "tag": "ma"
          },
          "large": {
            "tag": "mnull"
          },
          "dynamic": {
            "url": "https://media.sample.com/image/upload/b_rgb:e9eaeb/f_auto,q_auto/01/3240244_100106_m",
            "tag": "m0"
          }
        },
        "alternate": {
          "a": {
            "thumbnail": {
              "tag": "anull"
            },
            "medium": {
              "url": "https://images.sample.com/ca/4/product_assets/T/Z/L/D/8/BGTZLD8_aa.jpg",
              "tag": "aa"
            },
            "large": {
              "tag": "anull"
            },
            "dynamic": {
              "url": "https://media.sample.com/images/f_auto,q_auto/01/3240244_100106_a/blancha-mink-fur-belt-sheepskin-coat",
              "tag": "a0"
            }
          },
          "b": {
            "thumbnail": {
              "tag": "bnull"
            },
            "medium": {
              "url": "https://images.sample.com/ca/4/product_assets/T/Z/L/D/8/BGTZLD8_ba.jpg",
              "tag": "ba"
            },
            "large": {
              "tag": "bnull"
            },
            "dynamic": {
              "url": "https://media.sample.com/images/f_auto,q_auto/01/3240244_100106_b/blancha-mink-fur-belt-sheepskin-coat",
              "tag": "b0"
            }
          },
          "c": {
            "thumbnail": {
              "tag": "cnull"
            },
            "medium": {
              "url": "https://images.sample.com/ca/4/product_assets/T/Z/L/D/8/BGTZLD8_ca.jpg",
              "tag": "ca"
            },
            "large": {
              "tag": "cnull"
            },
            "dynamic": {
              "url": "https://media.sample.com/images/f_auto,q_auto/01/3240244_100106_c/blancha-mink-fur-belt-sheepskin-coat",
              "tag": "c0"
            }
          },
          "z": {
            "thumbnail": {
              "tag": "znull"
            },
            "medium": {
              "url": "https://images.sample.com/ca/4/product_assets/T/Z/L/D/8/BGTZLD8_za.jpg",
              "tag": "za"
            },
            "large": {
              "tag": "znull"
            },
            "dynamic": {
              "url": "https://media.sample.com/images/f_auto,q_auto/01/3240244_100106_z/blancha-mink-fur-belt-sheepskin-coat",
              "tag": "z0"
            }
          }
        }
      },
      "price": {
        "currencyCode": "$",
        "retailPrice": "2116.00",
        "adornments": [
          {
            "label": "Original",
            "price": "5290.00"
          },
          {
            "label": "NOW",
            "price": "2116.00"
          }
        ]
      },
      "preOrder": false,
      "productFlags": {
        "hasMoreColors": false,
        "isOnlyAtNM": false,
        "showMonogramLabel": false,
        "isNewArrival": false,
        "inLookBook": false,
        "dynamicImageSkuColor": false,
        "isEditorial": false
      },
      "sellableDate": "2019-11-01 07:00:19",
      "isGroup": false,
      "hasMoreItems": false,
      "source": "REGULAR",
      "onlyXItemsLeftStockLevel": 2,
      "isFavorite": false
    },
    {
      "id": "prod152131030",
      "name": "Plaid Silk-Cotton Sheath Dress",
      "displayable": true,
      "canonical": "/p/kiton-plaid-silk-cotton-sheath-dress-prod152131030",
      "designer": "Kiton",
      "cmosCatalog": "BGS20",
      "cmosItem": "B5A8H",
      "pimStyle": "3296059",
      "media": {
        "main": {
          "thumbnail": {
            "tag": "mnull"
          },
          "medium": {
            "url": "https://images.sample.com/ca/1/product_assets/B/5/A/8/H/BGB5A8H_ma.jpg",
            "tag": "ma"
          },
          "large": {
            "tag": "mnull"
          },
          "dynamic": {
            "url": "https://media.sample.com/images/f_auto,q_auto/01/3296059_m/kiton-",
            "tag": "m0"
          }
        },
        "alternate": {
          "a": {
            "thumbnail": {
              "tag": "anull"
            },
            "medium": {
              "url": "https://images.sample.com/ca/1/product_assets/B/5/A/8/H/BGB5A8H_aa.jpg",
              "tag": "aa"
            },
            "large": {
              "tag": "anull"
            },
            "dynamic": {
              "url": "https://media.sample.com/images/f_auto,q_auto/01/3296059_a/kiton-",
              "tag": "a0"
            }
          },
          "b": {
            "thumbnail": {
              "tag": "bnull"
            },
            "medium": {
              "url": "https://images.sample.com/ca/1/product_assets/B/5/A/8/H/BGB5A8H_ba.jpg",
              "tag": "ba"
            },
            "large": {
              "tag": "bnull"
            },
            "dynamic": {
              "url": "https://media.sample.com/images/f_auto,q_auto/01/3296059_b/kiton-",
              "tag": "b0"
            }
          },
          "c": {
            "thumbnail": {
              "tag": "cnull"
            },
            "medium": {
              "url": "https://images.sample.com/ca/1/product_assets/B/5/A/8/H/BGB5A8H_ca.jpg",
              "tag": "ca"
            },
            "large": {
              "tag": "cnull"
            },
            "dynamic": {
              "url": "https://media.sample.com/images/f_auto,q_auto/01/3296059_c/kiton-",
              "tag": "c0"
            }
          },
          "z": {
            "thumbnail": {
              "tag": "znull"
            },
            "medium": {
              "url": "https://images.sample.com/ca/1/product_assets/B/5/A/8/H/BGB5A8H_za.jpg",
              "tag": "za"
            },
            "large": {
              "tag": "znull"
            },
            "dynamic": {
              "url": "https://media.sample.com/images/f_auto,q_auto/01/3296059_z/kiton-",
              "tag": "z0"
            }
          }
        }
      },
      "price": {
        "currencyCode": "$",
        "retailPrice": "2020.00"
      },
      "preOrder": false,
      "productFlags": {
        "hasMoreColors": false,
        "isOnlyAtNM": false,
        "showMonogramLabel": false,
        "isNewArrival": false,
        "inLookBook": false,
        "dynamicImageSkuColor": false,
        "isEditorial": false
      },
      "sellableDate": "2021-02-22 07:00:18",
      "isGroup": false,
      "hasMoreItems": false,
      "source": "REGULAR",
      "onlyXItemsLeftStockLevel": 7,
      "isFavorite": false
    },
    {
      "id": "prod150570044",
      "name": "Ludlow Fox Fur Reversible Coat",
      "displayable": true,
      "canonical": "/p/nicole-benisti-ludlow-fox-fur-reversible-coat-prod150570044",
      "designer": "Nicole Benisti",
      "cmosCatalog": "BGS20",
      "cmosItem": "TZDZD",
      "pimStyle": "3202571",
      "media": {
        "main": {
          "thumbnail": {
            "tag": "mnull"
          },
          "medium": {
            "url": "https://images.sample.com/ca/5/product_assets/T/Z/D/Z/D/BGTZDZD_ma.jpg",
            "tag": "ma"
          },
          "large": {
            "tag": "mnull"
          },
          "dynamic": {
            "url": "https://media.sample.com/images/f_auto,q_auto/01/3202571_100106_m/nicole-benisti-",
            "tag": "m0"
          }
        },
        "alternate": {
          "a": {
            "thumbnail": {
              "tag": "anull"
            },
            "medium": {
              "url": "https://images.sample.com/ca/5/product_assets/T/Z/D/Z/D/BGTZDZD_aa.jpg",
              "tag": "aa"
            },
            "large": {
              "tag": "anull"
            },
            "dynamic": {
              "url": "https://media.sample.com/images/f_auto,q_auto/01/3202571_100106_a/nicole-benisti-",
              "tag": "a0"
            }
          },
          "b": {
            "thumbnail": {
              "tag": "bnull"
            },
            "medium": {
              "url": "https://images.sample.com/ca/5/product_assets/T/Z/D/Z/D/BGTZDZD_ba.jpg",
              "tag": "ba"
            },
            "large": {
              "tag": "bnull"
            },
            "dynamic": {
              "url": "https://media.sample.com/images/f_auto,q_auto/01/3202571_100106_b/nicole-benisti-",
              "tag": "b0"
            }
          },
          "c": {
            "thumbnail": {
              "tag": "cnull"
            },
            "medium": {
              "url": "https://images.sample.com/ca/5/product_assets/T/Z/D/Z/D/BGTZDZD_ca.jpg",
              "tag": "ca"
            },
            "large": {
              "tag": "cnull"
            },
            "dynamic": {
              "url": "https://media.sample.com/images/f_auto,q_auto/01/3202571_100106_c/nicole-benisti-",
              "tag": "c0"
            }
          },
          "z": {
            "thumbnail": {
              "tag": "znull"
            },
            "medium": {
              "url": "https://images.sample.com/ca/5/product_assets/T/Z/D/Z/D/BGTZDZD_za.jpg",
              "tag": "za"
            },
            "large": {
              "tag": "znull"
            },
            "dynamic": {
              "url": "https://media.sample.com/images/f_auto,q_auto/01/3202571_100106_z/nicole-benisti-",
              "tag": "z0"
            }
          }
        }
      },
      "price": {
        "currencyCode": "$",
        "retailPrice": "2000.00"
      },
      "preOrder": false,
      "productFlags": {
        "hasMoreColors": false,
        "isOnlyAtNM": false,
        "showMonogramLabel": false,
        "isNewArrival": false,
        "inLookBook": false,
        "dynamicImageSkuColor": false,
        "isEditorial": false
      },
      "sellableDate": "2019-10-24 07:00:16",
      "isGroup": false,
      "hasMoreItems": false,
      "source": "REGULAR",
      "onlyXItemsLeftStockLevel": 2,
      "isFavorite": false
    },
    {
      "id": "prod151590087",
      "name": "Nidia Embroidered Shoulder-Cutout High-Low Gown",
      "displayable": true,
      "canonical": "/p/alice-olivia-nidia-embroidered-shoulder-cutout-high-low-gown-prod151590087",
      "designer": "Alice + Olivia",
      "cmosCatalog": "BGS20",
      "cmosItem": "TZNUZ",
      "pimStyle": "3255490",
      "media": {
        "main": {
          "thumbnail": {
            "tag": "mnull"
          },
          "medium": {
            "url": "https://images.sample.com/ca/1/product_assets/T/Z/N/U/Z/BGTZNUZ_ma.jpg",
            "tag": "ma"
          },
          "large": {
            "tag": "mnull"
          },
          "dynamic": {
            "url": "https://media.sample.com/images/f_auto,q_auto/01/3255490_m/-",
            "tag": "m0"
          }
        },
        "alternate": {
          "a": {
            "thumbnail": {
              "tag": "anull"
            },
            "medium": {
              "url": "https://images.sample.com/ca/1/product_assets/T/Z/N/U/Z/BGTZNUZ_aa.jpg",
              "tag": "aa"
            },
            "large": {
              "tag": "anull"
            },
            "dynamic": {
              "url": "https://media.sample.com/images/f_auto,q_auto/01/3255490_a/-",
              "tag": "a0"
            }
          },
          "b": {
            "thumbnail": {
              "tag": "bnull"
            },
            "medium": {
              "url": "https://images.sample.com/ca/1/product_assets/T/Z/N/U/Z/BGTZNUZ_ba.jpg",
              "tag": "ba"
            },
            "large": {
              "tag": "bnull"
            },
            "dynamic": {
              "url": "https://media.sample.com/images/f_auto,q_auto/01/3255490_b/-",
              "tag": "b0"
            }
          },
          "c": {
            "thumbnail": {
              "tag": "cnull"
            },
            "medium": {
              "url": "https://images.sample.com/ca/1/product_assets/T/Z/N/U/Z/BGTZNUZ_ca.jpg",
              "tag": "ca"
            },
            "large": {
              "tag": "cnull"
            },
            "dynamic": {
              "url": "https://media.sample.com/images/f_auto,q_auto/01/3255490_c/-",
              "tag": "c0"
            }
          },
          "z": {
            "thumbnail": {
              "tag": "znull"
            },
            "medium": {
              "url": "https://images.sample.com/ca/1/product_assets/T/Z/N/U/Z/BGTZNUZ_za.jpg",
              "tag": "za"
            },
            "large": {
              "tag": "znull"
            },
            "dynamic": {
              "url": "https://media.sample.com/images/f_auto,q_auto/01/3255490_z/-",
              "tag": "z0"
            }
          }
        }
      },
      "price": {
        "currencyCode": "$",
        "retailPrice": "1995.00"
      },
      "preOrder": false,
      "productFlags": {
        "hasMoreColors": false,
        "isOnlyAtNM": false,
        "showMonogramLabel": false,
        "isNewArrival": false,
        "inLookBook": false,
        "dynamicImageSkuColor": false,
        "isEditorial": false
      },
      "sellableDate": "2021-01-16 07:00:07",
      "isGroup": false,
      "hasMoreItems": false,
      "source": "REGULAR",
      "onlyXItemsLeftStockLevel": 1,
      "isFavorite": false
    },
    {
      "id": "prod151550081",
      "name": "Shearling Moto Jacket",
      "displayable": true,
      "canonical": "/p/vince-shearling-moto-jacket-prod151550081",
      "designer": "Vince",
      "cmosCatalog": "BGS20",
      "cmosItem": "TZND5",
      "pimStyle": "3247318",
      "media": {
        "main": {
          "thumbnail": {
            "tag": "mnull"
          },
          "medium": {
            "url": "https://images.sample.com/ca/2/product_assets/T/Z/N/D/5/BGTZND5_ma.jpg",
            "tag": "ma"
          },
          "large": {
            "tag": "mnull"
          },
          "dynamic": {
            "url": "https://media.sample.com/images/f_auto,q_auto/01/3247318_100664_m/vince-shearling-moto-jacket",
            "tag": "m0"
          }
        },
        "alternate": {
          "a": {
            "thumbnail": {
              "tag": "anull"
            },
            "medium": {
              "url": "https://images.sample.com/ca/2/product_assets/T/Z/N/D/5/BGTZND5_aa.jpg",
              "tag": "aa"
            },
            "large": {
              "tag": "anull"
            },
            "dynamic": {
              "url": "https://media.sample.com/images/f_auto,q_auto/01/3247318_100664_a/vince-shearling-moto-jacket",
              "tag": "a0"
            }
          },
          "b": {
            "thumbnail": {
              "tag": "bnull"
            },
            "medium": {
              "url": "https://images.sample.com/ca/2/product_assets/T/Z/N/D/5/BGTZND5_ba.jpg",
              "tag": "ba"
            },
            "large": {
              "tag": "bnull"
            },
            "dynamic": {
              "url": "https://media.sample.com/images/f_auto,q_auto/01/3247318_100664_b/vince-shearling-moto-jacket",
              "tag": "b0"
            }
          },
          "c": {
            "thumbnail": {
              "tag": "cnull"
            },
            "medium": {
              "url": "https://images.sample.com/ca/2/product_assets/T/Z/N/D/5/BGTZND5_ca.jpg",
              "tag": "ca"
            },
            "large": {
              "tag": "cnull"
            },
            "dynamic": {
              "url": "https://media.sample.com/images/f_auto,q_auto/01/3247318_100664_c/vince-shearling-moto-jacket",
              "tag": "c0"
            }
          },
          "z": {
            "thumbnail": {
              "tag": "znull"
            },
            "medium": {
              "url": "https://images.sample.com/ca/2/product_assets/T/Z/N/D/5/BGTZND5_za.jpg",
              "tag": "za"
            },
            "large": {
              "tag": "znull"
            },
            "dynamic": {
              "url": "https://media.sample.com/images/f_auto,q_auto/01/3247318_100664_z/vince-shearling-moto-jacket",
              "tag": "z0"
            }
          }
        }
      },
      "price": {
        "currencyCode": "$",
        "retailPrice": "1995.00"
      },
      "preOrder": false,
      "productFlags": {
        "hasMoreColors": false,
        "isOnlyAtNM": false,
        "showMonogramLabel": false,
        "isNewArrival": false,
        "inLookBook": false,
        "dynamicImageSkuColor": false,
        "isEditorial": false
      },
      "sellableDate": "2019-10-28 18:00:04",
      "isGroup": false,
      "hasMoreItems": false,
      "source": "REGULAR",
      "onlyXItemsLeftStockLevel": 25,
      "isFavorite": false
    },
    {
      "id": "prod153930118",
      "name": "Wavelength Placement Print Midi Dress",
      "displayable": true,
      "canonical": "/p/zimmermann-wavelength-placement-print-midi-dress-prod153930118",
      "designer": "Zimmermann",
      "cmosCatalog": "BGS20",
      "cmosItem": "T0B97",
      "pimStyle": "3394692",
      "media": {
        "main": {
          "thumbnail": {
            "tag": "mnull"
          },
          "medium": {
            "url": "https://images.sample.com/ca/1/product_assets/T/0/B/9/7/BGT0B97_ma.jpg",
            "tag": "ma"
          },
          "large": {
            "tag": "mnull"
          },
          "dynamic": {
            "url": "https://media.sample.com/images/f_auto,q_auto/01/3394692_m/zimmermann-",
            "tag": "m0"
          }
        },
        "alternate": {
          "a": {
            "thumbnail": {
              "tag": "anull"
            },
            "medium": {
              "url": "https://images.sample.com/ca/1/product_assets/T/0/B/9/7/BGT0B97_aa.jpg",
              "tag": "aa"
            },
            "large": {
              "tag": "anull"
            },
            "dynamic": {
              "url": "https://media.sample.com/images/f_auto,q_auto/01/3394692_a/zimmermann-",
              "tag": "a0"
            }
          },
          "b": {
            "thumbnail": {
              "tag": "bnull"
            },
            "medium": {
              "url": "https://images.sample.com/ca/1/product_assets/T/0/B/9/7/BGT0B97_ba.jpg",
              "tag": "ba"
            },
            "large": {
              "tag": "bnull"
            },
            "dynamic": {
              "url": "https://media.sample.com/images/f_auto,q_auto/01/3394692_b/zimmermann-",
              "tag": "b0"
            }
          },
          "c": {
            "thumbnail": {
              "tag": "cnull"
            },
            "medium": {
              "url": "https://images.sample.com/ca/1/product_assets/T/0/B/9/7/BGT0B97_ca.jpg",
              "tag": "ca"
            },
            "large": {
              "tag": "cnull"
            },
            "dynamic": {
              "url": "https://media.sample.com/images/f_auto,q_auto/01/3394692_c/zimmermann-",
              "tag": "c0"
            }
          },
          "z": {
            "thumbnail": {
              "tag": "znull"
            },
            "medium": {
              "url": "https://images.sample.com/ca/1/product_assets/T/0/B/9/7/BGT0B97_za.jpg",
              "tag": "za"
            },
            "large": {
              "tag": "znull"
            },
            "dynamic": {
              "url": "https://media.sample.com/images/f_auto,q_auto/01/3394692_z/zimmermann-",
              "tag": "z0"
            }
          }
        }
      },
      "price": {
        "currencyCode": "$",
        "retailPrice": "1950.00"
      },
      "preOrder": true,
      "productFlags": {
        "hasMoreColors": false,
        "isOnlyAtNM": false,
        "showMonogramLabel": false,
        "isNewArrival": false,
        "inLookBook": false,
        "dynamicImageSkuColor": false,
        "isEditorial": false
      },
      "sellableDate": "2021-02-17 18:00:06",
      "isGroup": false,
      "parentGroupIds": [
        "prod156750013"
      ],
      "hasMoreItems": false,
      "source": "REGULAR",
      "onlyXItemsLeftStockLevel": 0,
      "isFavorite": false
    },
    {
      "id": "prod153910043",
      "name": "Wavelength Spliced Mini Dress",
      "displayable": true,
      "canonical": "/p/zimmermann-wavelength-spliced-mini-dress-prod153910043",
      "designer": "Zimmermann",
      "cmosCatalog": "BGS20",
      "cmosItem": "T0AH5",
      "pimStyle": "3394828",
      "media": {
        "main": {
          "thumbnail": {
            "tag": "mnull"
          },
          "medium": {
            "url": "https://images.sample.com/ca/1/product_assets/T/0/A/H/5/BGT0AH5_ma.jpg",
            "tag": "ma"
          },
          "large": {
            "tag": "mnull"
          },
          "dynamic": {
            "url": "https://media.sample.com/images/f_auto,q_auto/01/3394828_m/zimmermann-",
            "tag": "m0"
          }
        },
        "alternate": {
          "a": {
            "thumbnail": {
              "tag": "anull"
            },
            "medium": {
              "url": "https://images.sample.com/ca/1/product_assets/T/0/A/H/5/BGT0AH5_aa.jpg",
              "tag": "aa"
            },
            "large": {
              "tag": "anull"
            },
            "dynamic": {
              "url": "https://media.sample.com/images/f_auto,q_auto/01/3394828_a/zimmermann-",
              "tag": "a0"
            }
          },
          "b": {
            "thumbnail": {
              "tag": "bnull"
            },
            "medium": {
              "url": "https://images.sample.com/ca/1/product_assets/T/0/A/H/5/BGT0AH5_ba.jpg",
              "tag": "ba"
            },
            "large": {
              "tag": "bnull"
            },
            "dynamic": {
              "url": "https://media.sample.com/images/f_auto,q_auto/01/3394828_b/zimmermann-",
              "tag": "b0"
            }
          },
          "c": {
            "thumbnail": {
              "tag": "cnull"
            },
            "medium": {
              "url": "https://images.sample.com/ca/1/product_assets/T/0/A/H/5/BGT0AH5_ca.jpg",
              "tag": "ca"
            },
            "large": {
              "tag": "cnull"
            },
            "dynamic": {
              "url": "https://media.sample.com/images/f_auto,q_auto/01/3394828_c/zimmermann-",
              "tag": "c0"
            }
          },
          "z": {
            "thumbnail": {
              "tag": "znull"
            },
            "medium": {
              "url": "https://images.sample.com/ca/1/product_assets/T/0/A/H/5/BGT0AH5_za.jpg",
              "tag": "za"
            },
            "large": {
              "tag": "znull"
            },
            "dynamic": {
              "url": "https://media.sample.com/images/f_auto,q_auto/01/3394828_z/zimmermann-",
              "tag": "z0"
            }
          }
        }
      },
      "price": {
        "currencyCode": "$",
        "retailPrice": "1950.00"
      },
      "preOrder": false,
      "productFlags": {
        "hasMoreColors": false,
        "isOnlyAtNM": false,
        "showMonogramLabel": false,
        "isNewArrival": false,
        "inLookBook": false,
        "dynamicImageSkuColor": false,
        "isEditorial": false
      },
      "sellableDate": "2021-02-17 11:00:20",
      "isGroup": false,
      "hasMoreItems": false,
      "source": "REGULAR",
      "onlyXItemsLeftStockLevel": 8,
      "isFavorite": false
    },
    {
      "id": "prod153930114",
      "name": "Wavelength Fringe Shirtdress",
      "displayable": true,
      "canonical": "/p/zimmermann-wavelength-fringe-shirtdress-prod153930114",
      "designer": "Zimmermann",
      "cmosCatalog": "BGS20",
      "cmosItem": "T0AH8",
      "pimStyle": "3394825",
      "media": {
        "main": {
          "thumbnail": {
            "tag": "mnull"
          },
          "medium": {
            "url": "https://images.sample.com/ca/1/product_assets/T/0/A/H/8/BGT0AH8_ma.jpg",
            "tag": "ma"
          },
          "large": {
            "tag": "mnull"
          },
          "dynamic": {
            "url": "https://media.sample.com/images/f_auto,q_auto/01/3394825_m/zimmermann-wavelength-fringe-shirtdress",
            "tag": "m0"
          }
        },
        "alternate": {
          "a": {
            "thumbnail": {
              "tag": "anull"
            },
            "medium": {
              "url": "https://images.sample.com/ca/1/product_assets/T/0/A/H/8/BGT0AH8_aa.jpg",
              "tag": "aa"
            },
            "large": {
              "tag": "anull"
            },
            "dynamic": {
              "url": "https://media.sample.com/images/f_auto,q_auto/01/3394825_a/zimmermann-wavelength-fringe-shirtdress",
              "tag": "a0"
            }
          },
          "b": {
            "thumbnail": {
              "tag": "bnull"
            },
            "medium": {
              "url": "https://images.sample.com/ca/1/product_assets/T/0/A/H/8/BGT0AH8_ba.jpg",
              "tag": "ba"
            },
            "large": {
              "tag": "bnull"
            },
            "dynamic": {
              "url": "https://media.sample.com/images/f_auto,q_auto/01/3394825_b/zimmermann-wavelength-fringe-shirtdress",
              "tag": "b0"
            }
          },
          "c": {
            "thumbnail": {
              "tag": "cnull"
            },
            "medium": {
              "url": "https://images.sample.com/ca/1/product_assets/T/0/A/H/8/BGT0AH8_ca.jpg",
              "tag": "ca"
            },
            "large": {
              "tag": "cnull"
            },
            "dynamic": {
              "url": "https://media.sample.com/images/f_auto,q_auto/01/3394825_c/zimmermann-wavelength-fringe-shirtdress",
              "tag": "c0"
            }
          },
          "z": {
            "thumbnail": {
              "tag": "znull"
            },
            "medium": {
              "url": "https://images.sample.com/ca/1/product_assets/T/0/A/H/8/BGT0AH8_za.jpg",
              "tag": "za"
            },
            "large": {
              "tag": "znull"
            },
            "dynamic": {
              "url": "https://media.sample.com/images/f_auto,q_auto/01/3394825_z/zimmermann-wavelength-fringe-shirtdress",
              "tag": "z0"
            }
          }
        }
      },
      "price": {
        "currencyCode": "$",
        "retailPrice": "1950.00"
      },
      "preOrder": false,
      "productFlags": {
        "hasMoreColors": false,
        "isOnlyAtNM": false,
        "showMonogramLabel": false,
        "isNewArrival": false,
        "inLookBook": false,
        "dynamicImageSkuColor": false,
        "isEditorial": false
      },
      "sellableDate": "2021-01-02 11:00:04",
      "isGroup": false,
      "hasMoreItems": false,
      "source": "REGULAR",
      "onlyXItemsLeftStockLevel": 8,
      "isFavorite": false
    },
    {
      "id": "prod154640051",
      "name": "Chiffon Ruched Dress",
      "displayable": true,
      "canonical": "/p/no-21-chiffon-ruched-dress-prod154640051",
      "designer": "No. 21",
      "cmosCatalog": "BGS20",
      "cmosItem": "T0G4U",
      "pimStyle": "3418730",
      "media": {
        "main": {
          "thumbnail": {
            "tag": "mnull"
          },
          "medium": {
            "url": "https://images.sample.com/ca/1/product_assets/T/0/G/4/U/BGT0G4U_ma.jpg",
            "tag": "ma"
          },
          "large": {
            "tag": "mnull"
          },
          "dynamic": {
            "url": "https://media.sample.com/images/f_auto,q_auto/01/3418730_m/no-21-chiffon-ruched-dress",
            "tag": "m0"
          }
        },
        "alternate": {
          "a": {
            "thumbnail": {
              "tag": "anull"
            },
            "medium": {
              "url": "https://images.sample.com/ca/1/product_assets/T/0/G/4/U/BGT0G4U_aa.jpg",
              "tag": "aa"
            },
            "large": {
              "tag": "anull"
            },
            "dynamic": {
              "url": "https://media.sample.com/images/f_auto,q_auto/01/3418730_a/no-21-chiffon-ruched-dress",
              "tag": "a0"
            }
          },
          "b": {
            "thumbnail": {
              "tag": "bnull"
            },
            "medium": {
              "url": "https://images.sample.com/ca/1/product_assets/T/0/G/4/U/BGT0G4U_ba.jpg",
              "tag": "ba"
            },
            "large": {
              "tag": "bnull"
            },
            "dynamic": {
              "url": "https://media.sample.com/images/f_auto,q_auto/01/3418730_b/no-21-chiffon-ruched-dress",
              "tag": "b0"
            }
          },
          "c": {
            "thumbnail": {
              "tag": "cnull"
            },
            "medium": {
              "url": "https://images.sample.com/ca/1/product_assets/T/0/G/4/U/BGT0G4U_ca.jpg",
              "tag": "ca"
            },
            "large": {
              "tag": "cnull"
            },
            "dynamic": {
              "url": "https://media.sample.com/images/f_auto,q_auto/01/3418730_c/no-21-chiffon-ruched-dress",
              "tag": "c0"
            }
          }
        }
      },
      "price": {
        "currencyCode": "$",
        "retailPrice": "1910.00"
      },
      "preOrder": false,
      "productFlags": {
        "hasMoreColors": false,
        "isOnlyAtNM": false,
        "showMonogramLabel": false,
        "isNewArrival": false,
        "inLookBook": false,
        "dynamicImageSkuColor": false,
        "isEditorial": false
      },
      "sellableDate": "2021-01-06 18:00:04",
      "isGroup": false,
      "hasMoreItems": false,
      "source": "REGULAR",
      "onlyXItemsLeftStockLevel": 3,
      "isFavorite": false
    },
    {
      "id": "prod150580200",
      "name": "Chelsea Intarsia Fur-Lined Coat",
      "displayable": true,
      "canonical": "/p/nicole-benisti-chelsea-intarsia-fur-lined-coat-prod150580200",
      "designer": "Nicole Benisti",
      "cmosCatalog": "BGS20",
      "cmosItem": "TZE5W",
      "pimStyle": "3202570",
      "media": {
        "main": {
          "thumbnail": {
            "tag": "mnull"
          },
          "medium": {
            "url": "https://images.sample.com/ca/3/product_assets/T/Z/E/5/W/BGTZE5W_ma.jpg",
            "tag": "ma"
          },
          "large": {
            "tag": "mnull"
          },
          "dynamic": {
            "url": "https://media.sample.com/images/f_auto,q_auto/01/3202570_100106_m/nicole-benisti-intarsia-fur-lined-coat",
            "tag": "m0"
          }
        },
        "alternate": {
          "a": {
            "thumbnail": {
              "tag": "anull"
            },
            "medium": {
              "url": "https://images.sample.com/ca/3/product_assets/T/Z/E/5/W/BGTZE5W_aa.jpg",
              "tag": "aa"
            },
            "large": {
              "tag": "anull"
            },
            "dynamic": {
              "url": "https://media.sample.com/images/f_auto,q_auto/01/3202570_100106_a/nicole-benisti-intarsia-fur-lined-coat",
              "tag": "a0"
            }
          },
          "b": {
            "thumbnail": {
              "tag": "bnull"
            },
            "medium": {
              "url": "https://images.sample.com/ca/3/product_assets/T/Z/E/5/W/BGTZE5W_ba.jpg",
              "tag": "ba"
            },
            "large": {
              "tag": "bnull"
            },
            "dynamic": {
              "url": "https://media.sample.com/images/f_auto,q_auto/01/3202570_100106_b/nicole-benisti-intarsia-fur-lined-coat",
              "tag": "b0"
            }
          },
          "c": {
            "thumbnail": {
              "tag": "cnull"
            },
            "medium": {
              "url": "https://images.sample.com/ca/3/product_assets/T/Z/E/5/W/BGTZE5W_ca.jpg",
              "tag": "ca"
            },
            "large": {
              "tag": "cnull"
            },
            "dynamic": {
              "url": "https://media.sample.com/images/f_auto,q_auto/01/3202570_100106_c/nicole-benisti-intarsia-fur-lined-coat",
              "tag": "c0"
            }
          },
          "z": {
            "thumbnail": {
              "tag": "znull"
            },
            "medium": {
              "url": "https://images.sample.com/ca/3/product_assets/T/Z/E/5/W/BGTZE5W_za.jpg",
              "tag": "za"
            },
            "large": {
              "tag": "znull"
            },
            "dynamic": {
              "url": "https://media.sample.com/images/f_auto,q_auto/01/3202570_100106_z/nicole-benisti-intarsia-fur-lined-coat",
              "tag": "z0"
            }
          }
        }
      },
      "price": {
        "currencyCode": "$",
        "retailPrice": "1900.00"
      },
      "preOrder": false,
      "productFlags": {
        "hasMoreColors": false,
        "isOnlyAtNM": false,
        "showMonogramLabel": false,
        "isNewArrival": false,
        "inLookBook": false,
        "dynamicImageSkuColor": false,
        "isEditorial": false
      },
      "sellableDate": "2019-10-24 07:00:16",
      "isGroup": false,
      "hasMoreItems": false,
      "source": "REGULAR",
      "onlyXItemsLeftStockLevel": 3,
      "isFavorite": false
    },
    {
      "id": "prod156540002",
      "name": "Brightside Rouleaux Mini",
      "displayable": true,
      "canonical": "/p/zimmermann-brightside-rouleaux-mini-prod156540002",
      "designer": "Zimmermann",
      "cmosCatalog": "BGS20",
      "cmosItem": "T0A8W",
      "pimStyle": "3394843",
      "media": {
        "main": {
          "thumbnail": {
            "tag": "mnull"
          },
          "medium": {
            "url": "https://images.sample.com/ca/4/product_assets/T/0/A/8/W/BGT0A8W_ma.jpg",
            "tag": "ma"
          },
          "large": {
            "tag": "mnull"
          },
          "dynamic": {
            "url": "https://media.sample.com/images/f_auto,q_auto/01/3394843_100075_m/zimmermann-brightside-rouleaux-dress",
            "tag": "m0"
          }
        },
        "alternate": {
          "a": {
            "thumbnail": {
              "tag": "anull"
            },
            "medium": {
              "url": "https://images.sample.com/ca/4/product_assets/T/0/A/8/W/BGT0A8W_aa.jpg",
              "tag": "aa"
            },
            "large": {
              "tag": "anull"
            },
            "dynamic": {
              "url": "https://media.sample.com/images/f_auto,q_auto/01/3394843_100075_a/zimmermann-brightside-rouleaux-dress",
              "tag": "a0"
            }
          },
          "b": {
            "thumbnail": {
              "tag": "bnull"
            },
            "medium": {
              "url": "https://images.sample.com/ca/4/product_assets/T/0/A/8/W/BGT0A8W_ba.jpg",
              "tag": "ba"
            },
            "large": {
              "tag": "bnull"
            },
            "dynamic": {
              "url": "https://media.sample.com/images/f_auto,q_auto/01/3394843_100075_b/zimmermann-brightside-rouleaux-dress",
              "tag": "b0"
            }
          },
          "c": {
            "thumbnail": {
              "tag": "cnull"
            },
            "medium": {
              "url": "https://images.sample.com/ca/4/product_assets/T/0/A/8/W/BGT0A8W_ca.jpg",
              "tag": "ca"
            },
            "large": {
              "tag": "cnull"
            },
            "dynamic": {
              "url": "https://media.sample.com/images/f_auto,q_auto/01/3394843_100075_c/zimmermann-brightside-rouleaux-dress",
              "tag": "c0"
            }
          },
          "z": {
            "thumbnail": {
              "tag": "znull"
            },
            "medium": {
              "url": "https://images.sample.com/ca/4/product_assets/T/0/A/8/W/BGT0A8W_za.jpg",
              "tag": "za"
            },
            "large": {
              "tag": "znull"
            },
            "dynamic": {
              "url": "https://media.sample.com/images/f_auto,q_auto/01/3394843_100075_z/zimmermann-brightside-rouleaux-dress",
              "tag": "z0"
            }
          }
        }
      },
      "price": {
        "currencyCode": "$",
        "retailPrice": "1850.00"
      },
      "preOrder": true,
      "productFlags": {
        "hasMoreColors": false,
        "isOnlyAtNM": false,
        "showMonogramLabel": false,
        "isNewArrival": false,
        "inLookBook": false,
        "dynamicImageSkuColor": false,
        "isEditorial": false
      },
      "sellableDate": "2021-03-06 15:00:03",
      "isGroup": false,
      "hasMoreItems": false,
      "source": "REGULAR",
      "onlyXItemsLeftStockLevel": 0,
      "isFavorite": false
    },
    {
      "id": "prod151330045",
      "name": "Super Eight Embroidered Mini Dress",
      "displayable": true,
      "canonical": "/p/zimmermann-super-eight-embroidered-mini-dress-prod151330045",
      "designer": "Zimmermann",
      "cmosCatalog": "BGS20",
      "cmosItem": "TZLFE",
      "pimStyle": "3238631",
      "media": {
        "main": {
          "thumbnail": {
            "tag": "mnull"
          },
          "medium": {
            "url": "https://images.sample.com/ca/3/product_assets/T/Z/L/F/E/BGTZLFE_ma.jpg",
            "tag": "ma"
          },
          "large": {
            "tag": "mnull"
          },
          "dynamic": {
            "url": "https://media.sample.com/image/upload/b_rgb:e9eaeb/f_auto,q_auto/01/3238631_100241_m",
            "tag": "m0"
          }
        },
        "alternate": {
          "a": {
            "thumbnail": {
              "tag": "anull"
            },
            "medium": {
              "url": "https://images.sample.com/ca/3/product_assets/T/Z/L/F/E/BGTZLFE_aa.jpg",
              "tag": "aa"
            },
            "large": {
              "tag": "anull"
            },
            "dynamic": {
              "url": "https://media.sample.com/images/f_auto,q_auto/01/3238631_100241_a/zimmermann-super-eight-embroidered-mini",
              "tag": "a0"
            }
          }
        }
      },
      "price": {
        "currencyCode": "$",
        "retailPrice": "1850.00"
      },
      "preOrder": false,
      "productFlags": {
        "hasMoreColors": false,
        "isOnlyAtNM": false,
        "showMonogramLabel": false,
        "isNewArrival": false,
        "inLookBook": false,
        "dynamicImageSkuColor": false,
        "isEditorial": false
      },
      "sellableDate": "2019-10-21 18:00:09",
      "isGroup": false,
      "hasMoreItems": false,
      "source": "REGULAR",
      "onlyXItemsLeftStockLevel": 3,
      "isFavorite": false
    },
    {
      "id": "prod150570008",
      "name": "Chelsea Solid Fox Fur Trimmed Puffer Coat",
      "displayable": true,
      "canonical": "/p/nicole-benisti-chelsea-solid-fox-fur-trimmed-puffer-coat-prod150570008",
      "designer": "Nicole Benisti",
      "cmosCatalog": "BGS20",
      "cmosItem": "TZDYZ",
      "pimStyle": "3202572",
      "media": {
        "main": {
          "thumbnail": {
            "tag": "mnull"
          },
          "medium": {
            "url": "https://images.sample.com/ca/2/product_assets/T/Z/D/Y/Z/BGTZDYZ_ma.jpg",
            "tag": "ma"
          },
          "large": {
            "tag": "mnull"
          },
          "dynamic": {
            "url": "https://media.sample.com/images/f_auto,q_auto/01/3202572_100331_m/nicole-benisti-solid-fox-fur-trimmed-puffer",
            "tag": "m0"
          }
        },
        "alternate": {
          "a": {
            "thumbnail": {
              "tag": "anull"
            },
            "medium": {
              "url": "https://images.sample.com/ca/2/product_assets/T/Z/D/Y/Z/BGTZDYZ_aa.jpg",
              "tag": "aa"
            },
            "large": {
              "tag": "anull"
            },
            "dynamic": {
              "url": "https://media.sample.com/images/f_auto,q_auto/01/3202572_100331_a/nicole-benisti-solid-fox-fur-trimmed-puffer",
              "tag": "a0"
            }
          },
          "b": {
            "thumbnail": {
              "tag": "bnull"
            },
            "medium": {
              "url": "https://images.sample.com/ca/2/product_assets/T/Z/D/Y/Z/BGTZDYZ_ba.jpg",
              "tag": "ba"
            },
            "large": {
              "tag": "bnull"
            },
            "dynamic": {
              "url": "https://media.sample.com/images/f_auto,q_auto/01/3202572_100331_b/nicole-benisti-solid-fox-fur-trimmed-puffer",
              "tag": "b0"
            }
          },
          "c": {
            "thumbnail": {
              "tag": "cnull"
            },
            "medium": {
              "url": "https://images.sample.com/ca/2/product_assets/T/Z/D/Y/Z/BGTZDYZ_ca.jpg",
              "tag": "ca"
            },
            "large": {
              "tag": "cnull"
            },
            "dynamic": {
              "url": "https://media.sample.com/images/f_auto,q_auto/01/3202572_100331_c/nicole-benisti-solid-fox-fur-trimmed-puffer",
              "tag": "c0"
            }
          },
          "z": {
            "thumbnail": {
              "tag": "znull"
            },
            "medium": {
              "url": "https://images.sample.com/ca/2/product_assets/T/Z/D/Y/Z/BGTZDYZ_za.jpg",
              "tag": "za"
            },
            "large": {
              "tag": "znull"
            },
            "dynamic": {
              "url": "https://media.sample.com/images/f_auto,q_auto/01/3202572_100331_z/nicole-benisti-solid-fox-fur-trimmed-puffer",
              "tag": "z0"
            }
          }
        }
      },
      "price": {
        "currencyCode": "$",
        "retailPrice": "1800.00"
      },
      "preOrder": false,
      "productFlags": {
        "hasMoreColors": false,
        "isOnlyAtNM": false,
        "showMonogramLabel": false,
        "isNewArrival": false,
        "inLookBook": false,
        "dynamicImageSkuColor": false,
        "isEditorial": false
      },
      "sellableDate": "2019-10-24 07:00:16",
      "isGroup": false,
      "hasMoreItems": false,
      "source": "REGULAR",
      "onlyXItemsLeftStockLevel": 1,
      "isFavorite": false
    },
    {
      "id": "prod150570296",
      "name": "Mayfair Fox Fur-Trimmed Hooded Puffer Coat",
      "displayable": true,
      "canonical": "/p/nicole-benisti-mayfair-fox-fur-trimmed-hooded-puffer-coat-prod150570296",
      "designer": "Nicole Benisti",
      "cmosCatalog": "BGS20",
      "cmosItem": "TZE3Z",
      "pimStyle": "3202656",
      "media": {
        "main": {
          "thumbnail": {
            "tag": "mnull"
          },
          "medium": {
            "url": "https://images.sample.com/ca/2/product_assets/T/Z/E/3/Z/BGTZE3Z_ma.jpg",
            "tag": "ma"
          },
          "large": {
            "tag": "mnull"
          },
          "dynamic": {
            "url": "https://media.sample.com/images/f_auto,q_auto/01/3202656_100613_m/nicole-benisti-fox-fur-trimmed-hood-puffer",
            "tag": "m0"
          }
        },
        "alternate": {
          "a": {
            "thumbnail": {
              "tag": "anull"
            },
            "medium": {
              "url": "https://images.sample.com/ca/2/product_assets/T/Z/E/3/Z/BGTZE3Z_aa.jpg",
              "tag": "aa"
            },
            "large": {
              "tag": "anull"
            },
            "dynamic": {
              "url": "https://media.sample.com/images/f_auto,q_auto/01/3202656_100613_a/nicole-benisti-fox-fur-trimmed-hood-puffer",
              "tag": "a0"
            }
          },
          "b": {
            "thumbnail": {
              "tag": "bnull"
            },
            "medium": {
              "url": "https://images.sample.com/ca/2/product_assets/T/Z/E/3/Z/BGTZE3Z_ba.jpg",
              "tag": "ba"
            },
            "large": {
              "tag": "bnull"
            },
            "dynamic": {
              "url": "https://media.sample.com/images/f_auto,q_auto/01/3202656_100613_b/nicole-benisti-fox-fur-trimmed-hood-puffer",
              "tag": "b0"
            }
          },
          "c": {
            "thumbnail": {
              "tag": "cnull"
            },
            "medium": {
              "url": "https://images.sample.com/ca/2/product_assets/T/Z/E/3/Z/BGTZE3Z_ca.jpg",
              "tag": "ca"
            },
            "large": {
              "tag": "cnull"
            },
            "dynamic": {
              "url": "https://media.sample.com/images/f_auto,q_auto/01/3202656_100613_c/nicole-benisti-fox-fur-trimmed-hood-puffer",
              "tag": "c0"
            }
          },
          "z": {
            "thumbnail": {
              "tag": "znull"
            },
            "medium": {
              "url": "https://images.sample.com/ca/2/product_assets/T/Z/E/3/Z/BGTZE3Z_za.jpg",
              "tag": "za"
            },
            "large": {
              "tag": "znull"
            },
            "dynamic": {
              "url": "https://media.sample.com/images/f_auto,q_auto/01/3202656_100613_z/nicole-benisti-fox-fur-trimmed-hood-puffer",
              "tag": "z0"
            }
          }
        }
      },
      "price": {
        "currencyCode": "$",
        "retailPrice": "1800.00"
      },
      "preOrder": false,
      "productFlags": {
        "hasMoreColors": false,
        "isOnlyAtNM": false,
        "showMonogramLabel": false,
        "isNewArrival": false,
        "inLookBook": false,
        "dynamicImageSkuColor": false,
        "isEditorial": false
      },
      "sellableDate": "2019-10-24 07:00:16",
      "isGroup": false,
      "hasMoreItems": false,
      "source": "REGULAR",
      "onlyXItemsLeftStockLevel": 1,
      "isFavorite": false
    },
    {
      "id": "prod151490044",
      "name": "3-in-1 Hooded Double Coat",
      "displayable": true,
      "canonical": "/p/jane-post-3-in-1-hooded-double-coat-prod151490044",
      "designer": "Jane Post",
      "cmosCatalog": "BGS20",
      "cmosItem": "TZMRE",
      "pimStyle": "3249102",
      "media": {
        "main": {
          "thumbnail": {
            "tag": "mnull"
          },
          "medium": {
            "url": "https://images.sample.com/ca/4/product_assets/T/Z/M/R/E/BGTZMRE_ma.jpg",
            "tag": "ma"
          },
          "large": {
            "tag": "mnull"
          },
          "dynamic": {
            "url": "https://media.sample.com/images/f_auto,q_auto/01/3249102_100106_m/jane-post-3-in-1-hooded-double-coat",
            "tag": "m0"
          }
        },
        "alternate": {
          "a": {
            "thumbnail": {
              "tag": "anull"
            },
            "medium": {
              "url": "https://images.sample.com/ca/4/product_assets/T/Z/M/R/E/BGTZMRE_aa.jpg",
              "tag": "aa"
            },
            "large": {
              "tag": "anull"
            },
            "dynamic": {
              "url": "https://media.sample.com/images/f_auto,q_auto/01/3249102_100106_a/jane-post-3-in-1-hooded-double-coat",
              "tag": "a0"
            }
          },
          "b": {
            "thumbnail": {
              "tag": "bnull"
            },
            "medium": {
              "url": "https://images.sample.com/ca/4/product_assets/T/Z/M/R/E/BGTZMRE_ba.jpg",
              "tag": "ba"
            },
            "large": {
              "tag": "bnull"
            },
            "dynamic": {
              "url": "https://media.sample.com/images/f_auto,q_auto/01/3249102_100106_b/jane-post-3-in-1-hooded-double-coat",
              "tag": "b0"
            }
          },
          "c": {
            "thumbnail": {
              "tag": "cnull"
            },
            "medium": {
              "url": "https://images.sample.com/ca/4/product_assets/T/Z/M/R/E/BGTZMRE_ca.jpg",
              "tag": "ca"
            },
            "large": {
              "tag": "cnull"
            },
            "dynamic": {
              "url": "https://media.sample.com/images/f_auto,q_auto/01/3249102_100106_c/jane-post-3-in-1-hooded-double-coat",
              "tag": "c0"
            }
          }
        }
      },
      "price": {
        "currencyCode": "$",
        "retailPrice": "1795.00"
      },
      "preOrder": false,
      "productFlags": {
        "hasMoreColors": false,
        "isOnlyAtNM": false,
        "showMonogramLabel": false,
        "isNewArrival": false,
        "inLookBook": false,
        "dynamicImageSkuColor": false,
        "isEditorial": false
      },
      "sellableDate": "2019-10-10 07:00:16",
      "isGroup": false,
      "hasMoreItems": false,
      "source": "REGULAR",
      "onlyXItemsLeftStockLevel": 14,
      "isFavorite": false
    },
    {
      "id": "prod145860277",
      "name": "Double Layer Snap-Front Rain Coat",
      "displayable": true,
      "canonical": "/p/jane-post-double-layer-snap-front-rain-coat-prod145860277",
      "designer": "Jane Post",
      "cmosCatalog": "BGS20",
      "cmosItem": "TYDLQ",
      "pimStyle": "2332994",
      "media": {
        "main": {
          "thumbnail": {
            "tag": "mnull"
          },
          "medium": {
            "url": "https://images.sample.com/ca/6/product_assets/T/Y/D/L/Q/BGTYDLQ_ma.jpg",
            "tag": "ma"
          },
          "large": {
            "tag": "mnull"
          },
          "dynamic": {
            "url": "https://media.sample.com/images/f_auto,q_auto/01/2332994_m/jane-post-double-layer-rain-coat",
            "tag": "m0"
          }
        },
        "alternate": {
          "a": {
            "thumbnail": {
              "tag": "anull"
            },
            "medium": {
              "url": "https://images.sample.com/ca/6/product_assets/T/Y/D/L/Q/BGTYDLQ_aa.jpg",
              "tag": "aa"
            },
            "large": {
              "tag": "anull"
            },
            "dynamic": {
              "url": "https://media.sample.com/images/f_auto,q_auto/01/2332994_a/jane-post-double-layer-rain-coat",
              "tag": "a0"
            }
          },
          "b": {
            "thumbnail": {
              "tag": "bnull"
            },
            "medium": {
              "url": "https://images.sample.com/ca/6/product_assets/T/Y/D/L/Q/BGTYDLQ_ba.jpg",
              "tag": "ba"
            },
            "large": {
              "tag": "bnull"
            },
            "dynamic": {
              "url": "https://media.sample.com/images/f_auto,q_auto/01/2332994_b/jane-post-double-layer-rain-coat",
              "tag": "b0"
            }
          },
          "c": {
            "thumbnail": {
              "tag": "cnull"
            },
            "medium": {
              "url": "https://images.sample.com/ca/6/product_assets/T/Y/D/L/Q/BGTYDLQ_ca.jpg",
              "tag": "ca"
            },
            "large": {
              "tag": "cnull"
            },
            "dynamic": {
              "url": "https://media.sample.com/images/f_auto,q_auto/01/2332994_c/jane-post-double-layer-rain-coat",
              "tag": "c0"
            }
          },
          "z": {
            "thumbnail": {
              "tag": "znull"
            },
            "medium": {
              "url": "https://images.sample.com/ca/6/product_assets/T/Y/D/L/Q/BGTYDLQ_za.jpg",
              "tag": "za"
            },
            "large": {
              "tag": "znull"
            },
            "dynamic": {
              "url": "https://media.sample.com/images/f_auto,q_auto/01/2332994_z/jane-post-double-layer-rain-coat",
              "tag": "z0"
            }
          }
        }
      },
      "price": {
        "currencyCode": "$",
        "retailPrice": "1795.00"
      },
      "preOrder": false,
      "productFlags": {
        "hasMoreColors": true,
        "isOnlyAtNM": false,
        "showMonogramLabel": false,
        "isNewArrival": false,
        "inLookBook": false,
        "dynamicImageSkuColor": true,
        "isEditorial": false
      },
      "sellableDate": "2019-03-08 07:00:15",
      "isGroup": false,
      "hasMoreItems": false,
      "source": "REGULAR",
      "onlyXItemsLeftStockLevel": 6,
      "isFavorite": false
    },
    {
      "id": "prod152131161",
      "name": "Silk Straight-Leg Pants",
      "displayable": true,
      "canonical": "/p/kiton-silk-straight-leg-pants-prod152131161",
      "designer": "Kiton",
      "cmosCatalog": "BGS20",
      "cmosItem": "B5A9E",
      "pimStyle": "3296060",
      "media": {
        "main": {
          "thumbnail": {
            "tag": "mnull"
          },
          "medium": {
            "url": "https://images.sample.com/ca/1/product_assets/B/5/A/9/E/BGB5A9E_ma.jpg",
            "tag": "ma"
          },
          "large": {
            "tag": "mnull"
          },
          "dynamic": {
            "url": "https://media.sample.com/images/f_auto,q_auto/01/3296060_m/kiton-",
            "tag": "m0"
          }
        },
        "alternate": {
          "a": {
            "thumbnail": {
              "tag": "anull"
            },
            "medium": {
              "url": "https://images.sample.com/ca/1/product_assets/B/5/A/9/E/BGB5A9E_aa.jpg",
              "tag": "aa"
            },
            "large": {
              "tag": "anull"
            },
            "dynamic": {
              "url": "https://media.sample.com/images/f_auto,q_auto/01/3296060_a/kiton-",
              "tag": "a0"
            }
          },
          "b": {
            "thumbnail": {
              "tag": "bnull"
            },
            "medium": {
              "url": "https://images.sample.com/ca/1/product_assets/B/5/A/9/E/BGB5A9E_ba.jpg",
              "tag": "ba"
            },
            "large": {
              "tag": "bnull"
            },
            "dynamic": {
              "url": "https://media.sample.com/images/f_auto,q_auto/01/3296060_b/kiton-",
              "tag": "b0"
            }
          },
          "c": {
            "thumbnail": {
              "tag": "cnull"
            },
            "medium": {
              "url": "https://images.sample.com/ca/1/product_assets/B/5/A/9/E/BGB5A9E_ca.jpg",
              "tag": "ca"
            },
            "large": {
              "tag": "cnull"
            },
            "dynamic": {
              "url": "https://media.sample.com/images/f_auto,q_auto/01/3296060_c/kiton-",
              "tag": "c0"
            }
          },
          "z": {
            "thumbnail": {
              "tag": "znull"
            },
            "medium": {
              "url": "https://images.sample.com/ca/1/product_assets/B/5/A/9/E/BGB5A9E_za.jpg",
              "tag": "za"
            },
            "large": {
              "tag": "znull"
            },
            "dynamic": {
              "url": "https://media.sample.com/images/f_auto,q_auto/01/3296060_z/kiton-",
              "tag": "z0"
            }
          }
        }
      },
      "price": {
        "currencyCode": "$",
        "retailPrice": "1790.00"
      },
      "preOrder": false,
      "productFlags": {
        "hasMoreColors": false,
        "isOnlyAtNM": false,
        "showMonogramLabel": false,
        "isNewArrival": false,
        "inLookBook": false,
        "dynamicImageSkuColor": false,
        "isEditorial": false
      },
      "sellableDate": "2021-01-16 07:00:24",
      "isGroup": false,
      "parentGroupIds": [
        "prod156010005"
      ],
      "hasMoreItems": false,
      "source": "REGULAR",
      "onlyXItemsLeftStockLevel": 1,
      "isFavorite": false
    },
    {
      "id": "prod152131126",
      "name": "Crepe Short-Sleeve Sheath Dress",
      "displayable": true,
      "canonical": "/p/kiton-crepe-short-sleeve-sheath-dress-prod152131126",
      "designer": "Kiton",
      "cmosCatalog": "BGS20",
      "cmosItem": "B5A96",
      "pimStyle": "3296066",
      "media": {
        "main": {
          "thumbnail": {
            "tag": "mnull"
          },
          "medium": {
            "url": "https://images.sample.com/ca/1/product_assets/B/5/A/9/6/BGB5A96_ma.jpg",
            "tag": "ma"
          },
          "large": {
            "tag": "mnull"
          },
          "dynamic": {
            "url": "https://media.sample.com/images/f_auto,q_auto/01/3296066_m/kiton-",
            "tag": "m0"
          }
        },
        "alternate": {
          "a": {
            "thumbnail": {
              "tag": "anull"
            },
            "medium": {
              "url": "https://images.sample.com/ca/1/product_assets/B/5/A/9/6/BGB5A96_aa.jpg",
              "tag": "aa"
            },
            "large": {
              "tag": "anull"
            },
            "dynamic": {
              "url": "https://media.sample.com/images/f_auto,q_auto/01/3296066_a/kiton-",
              "tag": "a0"
            }
          },
          "b": {
            "thumbnail": {
              "tag": "bnull"
            },
            "medium": {
              "url": "https://images.sample.com/ca/1/product_assets/B/5/A/9/6/BGB5A96_ba.jpg",
              "tag": "ba"
            },
            "large": {
              "tag": "bnull"
            },
            "dynamic": {
              "url": "https://media.sample.com/images/f_auto,q_auto/01/3296066_b/kiton-",
              "tag": "b0"
            }
          },
          "c": {
            "thumbnail": {
              "tag": "cnull"
            },
            "medium": {
              "url": "https://images.sample.com/ca/1/product_assets/B/5/A/9/6/BGB5A96_ca.jpg",
              "tag": "ca"
            },
            "large": {
              "tag": "cnull"
            },
            "dynamic": {
              "url": "https://media.sample.com/images/f_auto,q_auto/01/3296066_c/kiton-",
              "tag": "c0"
            }
          },
          "z": {
            "thumbnail": {
              "tag": "znull"
            },
            "medium": {
              "url": "https://images.sample.com/ca/1/product_assets/B/5/A/9/6/BGB5A96_za.jpg",
              "tag": "za"
            },
            "large": {
              "tag": "znull"
            },
            "dynamic": {
              "url": "https://media.sample.com/images/f_auto,q_auto/01/3296066_z/kiton-",
              "tag": "z0"
            }
          }
        }
      },
      "price": {
        "currencyCode": "$",
        "retailPrice": "1785.00"
      },
      "preOrder": false,
      "productFlags": {
        "hasMoreColors": false,
        "isOnlyAtNM": false,
        "showMonogramLabel": false,
        "isNewArrival": false,
        "inLookBook": false,
        "dynamicImageSkuColor": false,
        "isEditorial": false
      },
      "sellableDate": "2021-02-11 07:00:19",
      "isGroup": false,
      "hasMoreItems": false,
      "source": "REGULAR",
      "onlyXItemsLeftStockLevel": 3,
      "isFavorite": false
    },
    {
      "id": "prod153700057",
      "name": "Shawl-Collar Walker Coat with Fox Fur Trim",
      "displayable": true,
      "canonical": "/p/fleurette-shawl-collar-walker-coat-with-fox-fur-trim-prod153700057",
      "designer": "Fleurette",
      "cmosCatalog": "BGS20",
      "cmosItem": "TZD0X",
      "pimStyle": "3202341",
      "media": {
        "main": {
          "thumbnail": {
            "tag": "mnull"
          },
          "medium": {
            "url": "https://images.sample.com/ca/1/product_assets/T/Z/D/0/X/BGTZD0X_ma.jpg",
            "tag": "ma"
          },
          "large": {
            "tag": "mnull"
          },
          "dynamic": {
            "url": "https://media.sample.com/images/f_auto,q_auto/01/3202341_m/fleurette-shawl-collar-walker-coat-wit",
            "tag": "m0"
          }
        },
        "alternate": {
          "a": {
            "thumbnail": {
              "tag": "anull"
            },
            "medium": {
              "url": "https://images.sample.com/ca/1/product_assets/T/Z/D/0/X/BGTZD0X_aa.jpg",
              "tag": "aa"
            },
            "large": {
              "tag": "anull"
            },
            "dynamic": {
              "url": "https://media.sample.com/images/f_auto,q_auto/01/3202341_a/fleurette-shawl-collar-walker-coat-wit",
              "tag": "a0"
            }
          },
          "b": {
            "thumbnail": {
              "tag": "bnull"
            },
            "medium": {
              "url": "https://images.sample.com/ca/1/product_assets/T/Z/D/0/X/BGTZD0X_ba.jpg",
              "tag": "ba"
            },
            "large": {
              "tag": "bnull"
            },
            "dynamic": {
              "url": "https://media.sample.com/images/f_auto,q_auto/01/3202341_b/fleurette-shawl-collar-walker-coat-wit",
              "tag": "b0"
            }
          },
          "c": {
            "thumbnail": {
              "tag": "cnull"
            },
            "medium": {
              "url": "https://images.sample.com/ca/1/product_assets/T/Z/D/0/X/BGTZD0X_ca.jpg",
              "tag": "ca"
            },
            "large": {
              "tag": "cnull"
            },
            "dynamic": {
              "url": "https://media.sample.com/images/f_auto,q_auto/01/3202341_c/fleurette-shawl-collar-walker-coat-wit",
              "tag": "c0"
            }
          },
          "z": {
            "thumbnail": {
              "tag": "znull"
            },
            "medium": {
              "url": "https://images.sample.com/ca/1/product_assets/T/Z/D/0/X/BGTZD0X_za.jpg",
              "tag": "za"
            },
            "large": {
              "tag": "znull"
            },
            "dynamic": {
              "url": "https://media.sample.com/images/f_auto,q_auto/01/3202341_z/fleurette-shawl-collar-walker-coat-wit",
              "tag": "z0"
            }
          }
        }
      },
      "price": {
        "currencyCode": "$",
        "retailPrice": "1750.00"
      },
      "preOrder": false,
      "productFlags": {
        "hasMoreColors": false,
        "isOnlyAtNM": false,
        "showMonogramLabel": false,
        "isNewArrival": false,
        "inLookBook": false,
        "dynamicImageSkuColor": false,
        "isEditorial": false
      },
      "sellableDate": "2019-11-16 07:00:21",
      "isGroup": false,
      "hasMoreItems": false,
      "source": "REGULAR",
      "onlyXItemsLeftStockLevel": 2,
      "isFavorite": false
    },
    {
      "id": "prod151320201",
      "name": "Super Eight Corded Bauble Mini Dress",
      "displayable": true,
      "canonical": "/p/zimmermann-super-eight-corded-bauble-mini-dress-prod151320201",
      "designer": "Zimmermann",
      "cmosCatalog": "BGS20",
      "cmosItem": "TZLJ3",
      "pimStyle": "3236952",
      "media": {
        "main": {
          "thumbnail": {
            "tag": "mnull"
          },
          "medium": {
            "url": "https://images.sample.com/ca/3/product_assets/T/Z/L/J/3/BGTZLJ3_ma.jpg",
            "tag": "ma"
          },
          "large": {
            "tag": "mnull"
          },
          "dynamic": {
            "url": "https://media.sample.com/images/f_auto,q_auto/01/3236952_100241_m/zimmermann-super-eight-corded-mini-",
            "tag": "m0"
          }
        },
        "alternate": {
          "a": {
            "thumbnail": {
              "tag": "anull"
            },
            "medium": {
              "url": "https://images.sample.com/ca/3/product_assets/T/Z/L/J/3/BGTZLJ3_aa.jpg",
              "tag": "aa"
            },
            "large": {
              "tag": "anull"
            },
            "dynamic": {
              "url": "https://media.sample.com/images/f_auto,q_auto/01/3236952_100241_a/zimmermann-super-eight-corded-mini-",
              "tag": "a0"
            }
          },
          "b": {
            "thumbnail": {
              "tag": "bnull"
            },
            "medium": {
              "url": "https://images.sample.com/ca/3/product_assets/T/Z/L/J/3/BGTZLJ3_ba.jpg",
              "tag": "ba"
            },
            "large": {
              "tag": "bnull"
            },
            "dynamic": {
              "url": "https://media.sample.com/images/f_auto,q_auto/01/3236952_100241_b/zimmermann-super-eight-corded-mini-",
              "tag": "b0"
            }
          },
          "c": {
            "thumbnail": {
              "tag": "cnull"
            },
            "medium": {
              "url": "https://images.sample.com/ca/3/product_assets/T/Z/L/J/3/BGTZLJ3_ca.jpg",
              "tag": "ca"
            },
            "large": {
              "tag": "cnull"
            },
            "dynamic": {
              "url": "https://media.sample.com/images/f_auto,q_auto/01/3236952_100241_c/zimmermann-super-eight-corded-mini-",
              "tag": "c0"
            }
          }
        }
      },
      "price": {
        "currencyCode": "$",
        "retailPrice": "1750.00"
      },
      "preOrder": false,
      "productFlags": {
        "hasMoreColors": false,
        "isOnlyAtNM": false,
        "showMonogramLabel": false,
        "isNewArrival": false,
        "inLookBook": false,
        "dynamicImageSkuColor": false,
        "isEditorial": false
      },
      "sellableDate": "2019-10-28 18:00:04",
      "isGroup": false,
      "hasMoreItems": false,
      "source": "REGULAR",
      "onlyXItemsLeftStockLevel": 11,
      "isFavorite": false
    },
    {
      "id": "prod151490063",
      "name": "Fox Fur Shawl-Collar Wool Wrap Coat",
      "displayable": true,
      "canonical": "/p/fleurette-fox-fur-shawl-collar-wool-wrap-coat-prod151490063",
      "designer": "Fleurette",
      "cmosCatalog": "BGS20",
      "cmosItem": "TZMLU",
      "pimStyle": "3223692",
      "media": {
        "main": {
          "thumbnail": {
            "tag": "mnull"
          },
          "medium": {
            "url": "https://images.sample.com/ca/4/product_assets/T/Z/M/L/U/BGTZMLU_ma.jpg",
            "tag": "ma"
          },
          "large": {
            "tag": "mnull"
          },
          "dynamic": {
            "url": "https://media.sample.com/image/upload/b_rgb:e9eaeb/f_auto,q_auto/01/3223692_100106_m",
            "tag": "m0"
          }
        },
        "alternate": {
          "a": {
            "thumbnail": {
              "tag": "anull"
            },
            "medium": {
              "url": "https://images.sample.com/ca/4/product_assets/T/Z/M/L/U/BGTZMLU_aa.jpg",
              "tag": "aa"
            },
            "large": {
              "tag": "anull"
            },
            "dynamic": {
              "url": "https://media.sample.com/images/f_auto,q_auto/01/3223692_100106_a/fleurette-fox-shawl-collar-wool-coat",
              "tag": "a0"
            }
          },
          "b": {
            "thumbnail": {
              "tag": "bnull"
            },
            "medium": {
              "url": "https://images.sample.com/ca/4/product_assets/T/Z/M/L/U/BGTZMLU_ba.jpg",
              "tag": "ba"
            },
            "large": {
              "tag": "bnull"
            },
            "dynamic": {
              "url": "https://media.sample.com/images/f_auto,q_auto/01/3223692_100106_b/fleurette-fox-shawl-collar-wool-coat",
              "tag": "b0"
            }
          }
        }
      },
      "price": {
        "currencyCode": "$",
        "retailPrice": "1750.00"
      },
      "preOrder": false,
      "productFlags": {
        "hasMoreColors": false,
        "isOnlyAtNM": false,
        "showMonogramLabel": false,
        "isNewArrival": false,
        "inLookBook": false,
        "dynamicImageSkuColor": false,
        "isEditorial": false
      },
      "sellableDate": "2019-08-23 07:00:03",
      "isGroup": false,
      "hasMoreItems": false,
      "source": "REGULAR",
      "onlyXItemsLeftStockLevel": 1,
      "isFavorite": false
    }
  ]
}